<template>
  <div class="page_ mobile_ md_ sdsd">
    <img class="banner_" src="~@/assets/quote/1.jpg" />
    <div class="p_content_">
      <div class="top_">MediLink-Global中端小团体医疗保险 | 0-64周岁即可承保</div>
      <a-form class="horizontal_item_ label_w1_">
        <a-form-item label="客户名称">
          <a-input v-model="formInfo.name" placeholder="请输入准确名称" @blur="checkName"></a-input>
        </a-form-item>
        <p v-if="!isValidName && errTip" class="error-name">{{ errTip }}</p>
        <a-form-item label="保险期限">
          <label>1年</label>
        </a-form-item>
        <a-form-item label="期望生效日期">
          <a-date-picker
            @change="onChangeDate"
            placeholder="请选择生效日期"
            v-model="formInfo.effectDate"
            :disabledDate="disabledDate"
            style="width: 100%"
          />
        </a-form-item>
      </a-form>
      <div class="title_ bold_">保障方案选择</div>
      <div>
        <div v-for="(item, index) in planList" :key="index" class="section_">
          <div class="s_title_">
            <a-icon v-if="index > 0" @click="handleSubPlan(index)" class="left_" type="minus"></a-icon>
            计划{{ index + 1 }}保障方案
            <label
              @click="
                (item.unexpand = !item.unexpand), (planList = [...planList])
              "
              class="right_"
            >
              {{ item.unexpand ? "展开" : "收起" }}
              <a-icon :type="item.unexpand ? 'down' : 'up'"></a-icon>
            </label>
          </div>
          <a-form
            v-show="!item.unexpand"
            class="horizontal_item_ form_ label_w6_"
            :label-col="{ span: 8 }"
          >
            <div>
              <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">医院涵盖范围 :</a-col>
                <a-col :span="12">
                  <a-select @change="handleCalcPlanPremium(item)" v-model="item.extHospital">
                    <a-select-option key="0" value="0">仅公立</a-select-option>
                    <a-select-option key="1" value="1">公立+私立，不含昂贵</a-select-option>
                    <a-select-option key="2" value="2">公立+私立+昂贵自付40%</a-select-option>
                    <a-select-option key="3" value="3">公立+私立+昂贵自付20%</a-select-option>
                    <a-select-option key="4" value="4">公立+私立+昂贵</a-select-option>
                  </a-select>
                </a-col>
              </a-row>
              <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">
                  <div>保障地理范围 :</div>
                </a-col>
                <a-col :span="12">
                  <a-form-item class="bold_lable_">
                    <a-select @change="handleCalcPlanPremium(item)" v-model="item.areaCoverage">
                      <a-select-option key="0" value="0">中国大陆</a-select-option>
                      <a-select-option key="1" value="1" :disabled="item.extHospital == 0">大中华</a-select-option>
                      <a-select-option key="2" value="2" :disabled="item.extHospital == 0">全球除美加</a-select-option>
                      <a-select-option key="3" value="3" :disabled="item.extHospital == 0">全球除美</a-select-option>
                      <a-select-option key="4" value="4" :disabled="item.extHospital == 0">全球</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <!-- <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_"
                  >地理涵盖范围以外地区紧急医疗 :
                </a-col>
                <a-col :span="12">
                  <a-form-item class="bold_lable_">
                    <a-select
                      @change="handleCalcPlanPremium(item)"
                      v-model="item.outAreaMedical"
                    >
                      <a-select-option key="0" value="0"
                        >不包含</a-select-option
                      >
                      <a-select-option key="1" value="1"
                        >全额赔付</a-select-option
                      >
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>-->
              <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">年度最高保额 :</a-col>
                <a-col :span="12">
                  <a-form-item class="bold_lable_" label>
                    <a-select @change="handleCalcPlanPremium(item)" v-model="item.amount">
                      <a-select-option key="s_50" value="500000">50万</a-select-option>
                      <a-select-option key="s_100" value="1000000">100万</a-select-option>
                      <a-select-option key="s_200" value="2000000">200万</a-select-option>
                      <a-select-option key="s_300" value="3000000">300万</a-select-option>
                      <a-select-option key="s_500" value="5000000">500万</a-select-option>
                      <a-select-option key="s_800" value="8000000">800万</a-select-option>
                      <a-select-option key="s_1200" value="12000000">1200万</a-select-option>
                      <a-select-option key="s_2000" value="20000000">2000万</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>

              <!-- <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">个人年免赔额 : </a-col>
                <a-col :span="12"> 0元 </a-col>
              </a-row>

              <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">保险自付比例 : </a-col>
                <a-col :span="12"> 0% </a-col>
              </a-row>-->
              <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">直付服务 :</a-col>
                <a-col :span="12" class="bold_lable_">
                  <a-select @change="handleCalcPlanPremium(item)" v-model="item.zhfs">
                    <a-select-option key="0" value="0">不提供</a-select-option>
                    <a-select-option key="1" value="1">提供</a-select-option>
                  </a-select>
                </a-col>
              </a-row>

              <!-- <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">承保条件: </a-col>
                <a-col :span="12" class="bold_lable_">
                  <a-select
                    @change="handleCalcPlanPremium(item)"
                    v-model="item.cbtj"
                  >
                    <a-select-option key="0" value="0"
                      >LMHD承担一般既往症，除外重大既往症</a-select-option
                    >
                    <a-select-option key="1" value="1"
                      >FMU全面医学承保</a-select-option
                    >
                  </a-select>
                </a-col>
              </a-row>-->
              <!-- <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_">承保服务及福利 : </a-col>
                <a-col :span="12" class="bold_lable_"> 赔付条件 </a-col>
              </a-row>-->
              <!-- <a-row :span="24" class="table_item">
                <a-col :span="12" class="bold_lable_"
                  >受限于免赔额，共付比例，自付额以及最高限额 :
                </a-col>
                <a-col :span="12" class="bold_lable_">
                  当满足年自付限额（共付比例最高限额）后，100%赔付
                </a-col>
              </a-row>-->
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>必选保障：住院治疗保险金</span>
                <span @click="planDesc[0].unexpand = !planDesc[0].unexpand" class="h_right_">
                  {{ planDesc[0].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[0].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[0].unexpand" class="content_">
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">住院免赔额 :</a-col>
                  <a-col :span="12" class="bold_lable_">
                    <a-select @change="handleCalcPlanPremium(item)" v-model="item.zymbe">
                      <a-select-option key="0" value="0">0</a-select-option>
                      <a-select-option key="1" value="10000">10000</a-select-option>
                    </a-select>
                  </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">赔付比例 :</a-col>
                  <a-col :span="12" class="bold_lable_">100%</a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">等待期 :</a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.waitDay">
                        <a-select-option key="0" value="0">30天（意外情况除外）</a-select-option>
                        <a-select-option key="1" value="1">0天 （需提交在保证明）</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    膳食费+床位费:
                    <br />
                    <span class="l_span">双人病房（中国大陆公立性质医院可为单人病房)</span>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.zhuyuan">
                        <a-select-option key="0" value="0">800/天，最多180天</a-select-option>
                        <a-select-option key="1" value="1">1,200/天，最多180天</a-select-option>
                        <a-select-option key="2" value="2">1,500/天，最多180天</a-select-option>
                        <a-select-option key="3" value="3">2,000/天，最多180天</a-select-option>
                        <a-select-option key="4" value="4">3,000/天，最多180天</a-select-option>
                        <a-select-option key="5" value="5">赔付至住院年度限额</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    重症监护病房费（医疗必须）、医生费、护理费、治疗费、处方药费、耐用医疗设备、
                    检查费检验费、住院手术费、陪床费、康复治疗和专业护理费、矫形改造手术费、精神和心理疾病、临终关怀
                    :
                    <br />
                    <!-- <span class="l_span"
                      >被保险人接受医学必需的治疗，包含重症监护病房（ICUs）、心脏重症监护病房（CICUs）或新生儿重症监护病房（NICU）的合理费用。
                      · 累计限30天/保单年度</span 
                    >-->
                  </a-col>
                  <a-col :span="12">100%赔付</a-col>
                </a-row>
                <!-- <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">护理费 : </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">治疗费 : </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">检查化验费 : </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >手术室费和急诊室费 :
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >医师诊疗费、手术医师费和麻醉师费 :
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >陪床费 : <br />
                    <span class="l_span">
                      限未满十八周岁的附属被保险人的父母陪床 <br />
                      年限额：30天</span
                    >
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >康复治疗和专业护理费 : <br />
                    <span class="l_span">
                      入住经医疗服务供应商批准的机构接受的康复治疗和由专业护士实施的医学必需且合理的专业护理费用。
                      <br />
                      仅限于入院后需立即实施的治疗且每保单不超过90天</span
                    >
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >矫形改造手术 : <br />
                    <span class="l_span">
                      被保险人接受矫形改造手术恢复肢体功能或容貌产生的矫形改造手术费用，但不包括与下颌异常或与颞下颌关节紊乱综合症有关的病症，且手术需满足下列前提条件：
                      <br />
                      1)手术或治疗旨在恢复或改善功能；<br />
                      2)仅限于矫形改造手术，不包含非整容手术；<br />
                      3)该手术须是由于意外伤害或疾病造成的，且意外伤害或疾病发生时间应在本合同保险期间内。</span
                    >
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        @change="handleCalcPlanPremium(item)"
                        v-model="item.hosZL"
                      >
                        <a-select-option key="0" value="0"
                          >不包含</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >全额赔付</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >耐用医疗设备 : <br />
                    <span class="l_span">
                      轮椅、医院病床以及其它类似器材
                      <br />
                      租借费用最高以购置费用为限<br
                    /></span>
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >假肢装置 : <br />
                    <span class="l_span">
                      用以替代人体局部构造的假肢及其它装备
                      <br />
                      责任免除：助听器<br
                    /></span>
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >糖尿病辅助设备 : <br />
                    <span class="l_span">包括胰岛素泵及相关用品</span>
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 年限额 ¥35,000 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >重要器官衰竭移植费用（重要器官、骨髓、干细胞移植） : <br />
                    <span class="l_span"
                      >被保险人作为受体接受器官、骨髓移植的医学必需且合理的费用。
                      <br />
                      责任免除：器官移植供体寻找及获得等费用</span
                    >
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >精神和心理疾病 : <br />
                    <span class="l_span"
                      >医学必需且合理的精神和心理障碍治疗费。指经医师诊断和要求被保险人在医学认可的精神心理专科医疗机构或者设有精神心理科室的医疗机构，为治疗精神和心理障碍接受由具有相应专业资格的医师或者心理学家实施的住院或者门诊医疗和咨询费用
                      <br />
                      精神和心理障碍包括但不限于神经性贪食症、神经性厌食症、悲伤辅导和悲伤治疗、
                      注意力缺陷症、注意缺陷多动障碍、酒精和药物滥用戒断治疗。
                      <br />不包括智能测试、教育测试、婚姻和家庭心理咨询。</span
                    >
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        @change="handleCalcPlanPremium(item)"
                        v-model="item.hosJS"
                      >
                        <a-select-option key="0" value="0"
                          >不包含</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >2,000</a-select-option
                        >
                        <a-select-option key="2" value="2"
                          >3,000</a-select-option
                        >
                        <a-select-option key="3" value="3"
                          >5,000</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >临终关怀 : <br />
                    <span class="l_span"
                      >指曾被保险人因与该事故相应的病症或者相关的病症而现被诊断患终末期疾病且存活期二百四十日以下（含），经医疗服务供应商批准，该被保险人接受具有相应资质的临终关怀机构提供的、由专业人员和志愿者组成的跨学科队伍在医学指导下实施的姑息性、支持性医护设施而发生的费用（不包括保险期间届满后发生的临终关怀费用）。被保险人入住临终关怀机构接受临终关怀的，须基于病情和家庭必要
                    </span>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        @change="handleCalcPlanPremium(item)"
                        v-model="item.hosLZ"
                      >
                        <a-select-option key="0" value="0"
                          >不包含</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >终身限额¥35,000</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>-->

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    无理赔住院津贴 :
                    <br />
                    <!-- <span class="l_span"
                      >在满足以下条件基础上您将得到住院津贴：<br />
                      - 您所接受的治疗在本合同责任规定范围内<br />
                      - 住院治疗需过夜<br />
                      - 住院产生的所有费用不向本保险公司进行索赔<br />
                      若实际发生的金额低于住院津贴所能赔付的金额时，将按照实际发生的金额赔付。
                    </span>-->
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.wlpZYJT">
                        <a-select-option key="0" value="0">不包含</a-select-option>
                        <a-select-option key="1" value="1">500/天，最多10天</a-select-option>
                        <a-select-option key="2" value="2">1000/天，最多10天</a-select-option>
                        <!-- <a-select-option key="3" value="3"
                          >2,000/天，最多30天</a-select-option
                        >-->
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row class="table_item">
                  <a-col :span="12" class="bold_lable_">
                      住院治疗备注：
                  </a-col>
                  <a-col :span="12" class="bold_lable_">
                    <span class="l_span">
                      <br />1、床位费仅限双人病房，中国大陆可为标准单人病房。
                      <br />2、陪床费限未满十八周岁的附属被保险人的父母陪床，每年累计最高30日。
                      <br />3、康复治疗和专业护理费是指入住经医疗服务供应商批准的机构接受的康复治疗和由专业护士实施的医学必需且合理的专业护理费用。仅限于入院后需立即实施的治疗且每年累计最高90日。
                      <br />4、耐用医疗设备是指：轮椅、医院病床以及其它类似器材、假肢装置（除外助听器）、胰岛素泵及糖尿病辅助设备相关用品。
                      <br />5、临终关怀年限额45日。
                      <br />6、无理赔住院津贴需符合以下条件：在同时满足以下条件基础上将得到无理赔住院津贴：
                      <br />（1）您所接受的治疗在本合同责任规定范围内；
                      <br />（2）住院治疗需过夜；
                      <br />（3）本次住院产生的医疗费用从社保或其他商业保险获得不低于50%的赔偿
                    </span>
                  </a-col>
                </a-row>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：门诊治疗保险金</span>
                <span @click="planDesc[1].unexpand = !planDesc[1].unexpand" class="h_right_">
                  {{ planDesc[1].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[1].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[1].unexpand" class="content_">
                <!-- <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">门诊医疗保障: </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        v-model="item.mzBZ"
                        @change="(val) => handlePlanChange(val, item)"
                      >
                        <a-select-option key="0" value="0"
                          >不附加</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >附加</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>-->
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">门诊年度限额:</a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.menzhenLimit">
                        <a-select-option
                          v-for="(item, index) in planValueOptions"
                          :key="index"
                          :value="item.value"
                        >{{ item.name }}</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div v-if="item.menzhenLimit > 0" class="border_ label_w3_ mrg_">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">门诊免赔额:</a-col>
                    <a-col :span="12" class="bold_lable_">
                      <a-form-item class="bold_lable_">
                        <a-select @change="handleCalcPlanPremium(item)" v-model="item.mzmpe">
                          <a-select-option key="0" value="1">0</a-select-option>
                          <a-select-option key="1" value="0.895">1,000</a-select-option>
                          <a-select-option key="2" value="0.8071">2,000</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">赔付比例:</a-col>
                    <a-col :span="12" class="bold_lable_">100%</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      治疗费、检查费检验费、处方药费、耐用医疗设备费、门诊或日间手术费、睡眠检查和治疗费、急诊室费、紧急牙科治疗费、家庭护理费
                      :
                      <br />
                    </a-col>
                    <a-col :span="12" class="bold_lable_">赔付至门诊上限</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_ long">
                      医生费:
                      <br />
                      <!-- <span class="l_span"> 包含中医医师费、诊疗费</span> -->
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select @change="handleCalcPlanPremium(item)" v-model="item.yishiUpgrade">
                          <a-select-option key="0" value="0">无单次限额</a-select-option>
                          <a-select-option key="3" value="1">300/次</a-select-option>
                          <a-select-option key="5" value="2">500/次</a-select-option>
                          <a-select-option key="6" value="3">600/次</a-select-option>
                          <a-select-option key="8" value="4">800/次</a-select-option>
                          <a-select-option key="10" value="5">1,000/次</a-select-option>
                          <a-select-option key="12" value="6">1,200/次</a-select-option>
                          <a-select-option key="15" value="7">1,500/次</a-select-option>
                          <a-select-option key="2" value="8">2,000/次</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >处方药 : <br />
                      <span class="l_span">
                        医学必需、合理的且由医生开具的药物，如西药、中草药等。<br />
                        门诊处方药开药量应与开药时间间隔相匹配。保险人对超过限量部分不承担责任。</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_">
                      全额赔付 每次配药量以90天为限
                    </a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >检查化验费 :<br />
                      <span class="l_span">
                        化验费，如血液检查，尿检等;<br />
                        X-Rays; X 光检查费；<br />
                        · 超声波心动描记术费；<br />
                        · 超声波检查费</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >大型检查费 :<br />
                      <span class="l_span">
                        化验费，如血液检查，尿检等;<br />
                        X-Rays; X 光检查费；<br />
                        · 超声波心动描记术费；<br />
                        · 超声波检查费</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >门诊医疗设施或日间手术治疗和麻醉服务费用 :<br />
                      <span class="l_span">
                        医师办公室或其他独立的手术设施、手术医师费用和麻醉服务费用</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >门诊手术费 :<br />
                      <span class="l_span">
                        医学必需且合理的门诊手术相关的费用，包括但不限于：<br />
                        1. 手术费； <br />
                        2. 外科医生费； <br />
                        3.麻醉医生费；<br />
                        4. 手术室和恢复室费；<br />
                        5. 麻醉费及吸氧费；<br />
                        6. 输血、血浆、血浆扩容药物费；<br />
                        7. 医疗耗材费。</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >中草药费 :<br />
                      <span class="l_span">
                        由注册中医医师处方开具的医学必需且合理的中草药费用，且医师所处机构须为医疗机构。<br />
                        · 责任免除：主要起营养滋补作用的药品及膏方。</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >睡眠检查和治疗费 :<br />
                      <span class="l_span">
                        发作性睡眠或阻塞性呼吸暂停症状的医学必需且合理的检查和治疗费（包括其对应的睡眠监测检查、耐用医疗设备费用，如呼吸机及配件等）。</span
                      ></a-col
                    >
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.shuimianJC"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="2" value="2"
                            >2,000</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >中医针灸疗法和顺势疗法 :<br />
                      <span class="l_span">
                        对可保疾病的顺势疗法、针灸治疗及传统中医治疗包括中草药药品费等所有相关费用</span
                      ></a-col
                    >
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.zhongyiUpgrade"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="2" value="2"
                            >4,000</a-select-option
                          >
                          <a-select-option key="3" value="3"
                            >20,000</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>-->
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      理疗和中医治疗费 :
                      <br />
                      <!-- <span class="l_span">
                        物理治疗，脊柱指压治疗，职业性治疗法，语言障碍治疗和整骨治疗费。<br />
                        必须为具有医疗资质的专业医师在医疗机构提供的相关服务，且医师可以提供书面治疗计划。<br />责任免除：泥疗、蜡敷治疗、气泡浴与浸浴治疗。</span
                      >-->
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.liliaoUpgrade"
                        >
                          <a-select-option key="0" value="0">不包含</a-select-option>
                          <a-select-option key="1" value="312">2,000</a-select-option>
                          <a-select-option key="2" value="406">3,000</a-select-option>
                          <a-select-option key="3" value="536">5,000</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >耐用医疗设备 :<br />
                      <span class="l_span">
                        轮椅、医院病床以及其它类似器材<br />
                        · 租借费用最高以购置费用为限</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>-->

                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >耐用医疗设备 :<br />
                      <span class="l_span">
                        轮椅、医院病床以及其它类似器材<br />
                        · 租借费用最高以购置费用为限</span
                      ></a-col
                    >
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >假肢装置 : <br />
                      <span class="l_span">
                        用以替代人体局部构造的假肢及其它装备
                        <br />
                        责任免除：助听器<br
                      /></span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">中医治疗 : </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.chuantongZY"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="2" value="2"
                            >最高300/次，累计限20次</a-select-option
                          >
                          <a-select-option key="3" value="3"
                            >最高1,000/次，累计限20次</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >糖尿病辅助设备 : <br />
                      <span class="l_span">包括胰岛素泵及相关用品</span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_">
                      年限额 ¥35,000
                    </a-col>
                  </a-row>-->
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      精神和心理疾病 :
                      <br />
                      <!-- <span class="l_span"
                        >医学必需且合理的精神和心理障碍治疗费。指经医师诊断和要求被保险人在医学认可的精神心理专科医疗机构或者设有精神心理科室的医疗机构，为治疗精神和心理障碍接受由具有相应专业资格的医师或者心理学家实施的住院或者门诊医疗和咨询费用
                        <br />
                        精神和心理障碍包括但不限于神经性贪食症、神经性厌食症、悲伤辅导和悲伤治疗、
                        注意力缺陷症、注意缺陷多动障碍、酒精和药物滥用戒断治疗。
                        <br />不包括智能测试、教育测试、婚姻和家庭心理咨询。</span
                      >-->
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select @change="handleCalcPlanPremium(item)" v-model="item.mzJingshen">
                          <a-select-option key="0" value="0">不包含</a-select-option>
                          <a-select-option key="1" value="99">年限额2,000元</a-select-option>
                          <a-select-option key="2" value="132">年限额3,000元</a-select-option>
                          <a-select-option key="3" value="183">年限额5,000元</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >临终关怀 : <br />
                      <span class="l_span"
                        >指曾被保险人因与该事故相应的病症或者相关的病症而现被诊断患终末期疾病且存活期二百四十日以下（含），经医疗服务供应商批准，该被保险人接受具有相应资质的临终关怀机构提供的、由专业人员和志愿者组成的跨学科队伍在医学指导下实施的姑息性、支持性医护设施而发生的费用（不包括保险期间届满后发生的临终关怀费用）。被保险人入住临终关怀机构接受临终关怀的，须基于病情和家庭必要
                      </span>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.mzLZ"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="2" value="2"
                            >40,000</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >家庭健康护理（包括护理服务） : <br />
                      <span class="l_span">
                        和家族病史有关的医学必需且合理的筛查费，包括化验、检查、基因检测费及医生费。家族病是指某种表现出家族聚集现象的疾病，一个家族中（包括直系亲属、旁系亲属）多个成员患有同一种疾病。家族病不包括由于饮食、居住等环境因素相同，可能导致多个成员患有相同的疾病。
                      </span>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.jiatingHL"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >紧急牙科治疗 : <br />
                      <span class="l_span">
                        仅限由意外事故导致的对健康自然牙的修复或替换，首次治疗必须在遭受伤害后的30天内进行。<br />
                        · 责任免除：由咀嚼食物或咀嚼其他外物引起的牙齿伤害。
                      </span>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item class="bold_lable_" label="">
                        <a-select
                          @change="handleCalcPlanPremium(item)"
                          v-model="item.jjYK"
                        >
                          <a-select-option key="0" value="0"
                            >不包含</a-select-option
                          >
                          <a-select-option key="2" value="2"
                            >5,000</a-select-option
                          >
                          <a-select-option key="3" value="3"
                            >40,000</a-select-option
                          >
                          <a-select-option key="1" value="1"
                            >全额赔付</a-select-option
                          >
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >家族病史筛查 : <br />
                      <span class="l_span">
                        和家族病史有关的医学必需且合理的筛查费，包括化验、检查、基因检测费及医生费。家族病是指某种表现出家族聚集现象的疾病，一个家族中（包括直系亲属、旁系亲属）多个成员患有同一种疾病。家族病不包括由于饮食、居住等环境因素相同，可能导致多个成员患有相同的疾病。
                      </span>
                    </a-col>
                    <a-col :span="12"> 年限额¥2,000 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >视力与听力检查 : <br />
                      <span class="l_span">
                        15岁以下附带被保险人可享受每年一次视力检查和听力检查。
                      </span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >旅行预防接种 : <br />
                      <span class="l_span">
                        用于支付与旅行相关的预防接种费用。
                      </span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >荷尔蒙替代治疗 :
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>-->
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                        门诊医疗备注：
                    </a-col>
                    <a-col :span="12" class="bold_lable_">
                      <span class="l_span">
                        <br />1、耐用医疗设备定义及范围同住院福利。
                        <br />2、家庭护理费每年累计最高30日。
                        <br />3、处方药每次配药量以90日为限。
                        <br />4、中医治疗包含中药草、针灸、挂号、诊疗。
                        <br />
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：紧急医疗保险金</span>
                <span @click="planDesc[2].unexpand = !planDesc[2].unexpand" class="h_right_">
                  {{ planDesc[2].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[2].unexpand" class="content_">
                <!-- <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >可选紧急医疗福利 :
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        @change="handleCalcPlanPremium(item)"
                        v-model="item.emergencyMedical"
                      >
                        <a-select-option key="0" value="0"
                          >不附加</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >附加</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>-->
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">紧急医疗费年度限额 :</a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.jjylndxe">
                        <a-select-option key="0" value="1">不涵盖</a-select-option>
                        <a-select-option key="1" value="1.02">赔付至年度最高保额</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div v-if="item.jjylndxe > 1" class="border_ label_w3_ mrg_">
                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >急诊室费和急诊医疗服务费 :
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>-->

                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >在美国非紧急情况下的使用急诊室费用 :
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                  </a-row>-->

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      救护车费（仅限地面转运至距离最近的医院）、紧急医疗运送和转运费
                      :
                      <br />
                      <!-- <span class="l_span">
                        仅限地面转运（至距离最近的医院）
                      </span>-->
                    </a-col>
                    <a-col :span="12" class="bold_lable_">100%赔付</a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">住宿费:</a-col>
                    <a-col :span="12" class="bold_lable_">限800元/日，每年累计最高12日</a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      遗体遣返或就地安葬费 :
                      <br />
                      <!-- <span class="l_span">
                        紧急空中转运（当发生紧急情况被保险人需要立刻接受治疗时，需要用空中救援飞机，比如直升机从事故地点运送到合适的医疗机构的费用。）<br />
                        住宿费（必须得到保险公司医疗协调机构批准）
                        发生紧急医疗转运时，承担一位陪同人员陪同医疗转运的住宿费
                      </span>-->
                    </a-col>
                    <a-col :span="12" class="bold_lable_">年限额160,000元</a-col>
                  </a-row>
                  <!-- <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >遗体遣返或就地安葬 : <br />
                      <span class="l_span">
                        被保险人在本保障地域范围内身故；<br />
                        被保险人在国籍国外国家或者地区身故；<br />
                        对于遗体运返，被保险人的国籍国必须在本保障地域范围内。<br />
                      </span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_">
                      限额：¥160,000
                    </a-col>
                  </a-row>-->
                </div>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：特殊医疗福利 (受限于住院和门诊上限)</span>
                <span @click="planDesc[3].unexpand = !planDesc[3].unexpand" class="h_right_">
                  {{ planDesc[3].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[3].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[3].unexpand" class="content_">
                <!-- <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >特殊医疗福利 (受限于住院和门诊上限) :
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        v-model="item.teshuZL"
                        @change="(val) => handlePlanChange(val, item)"
                      >
                        <a-select-option key="0" value="0"
                          >不附加</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >附加</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div class="border_ label_w3_ mrg_" v-if="item.teshuZL > 0">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_"
                      >门诊癌症治疗及门诊肾透析:<br />
                      <span class="l_span">
                        医学必需且合理的恶性肿瘤门诊化学治疗费、恶性肿瘤门诊放射治疗费、恶性肿瘤门诊靶向治疗费、门诊肾透析。
                      </span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>-->

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    既往症:
                    <br />
                    <!-- <span class="l_span">
                        既往症是指在保险责任生效前，被保险人就已接受诊断、医学咨询或者治疗，或者服用药物，或者显现症状的疾病或损伤。
                    </span>-->
                  </a-col>
                  <a-col :span="12" class="bold_lable_">
                    <a-form-item class="bold_lable_">
                      <a-select v-model="item.tsjwz" @change="(val) => handlePlanChange(val, item)">
                        <a-select-option key="0" value="0">FMU,提交个人健康告知，逐个核保</a-select-option>
                        <a-select-option key="1" value="1">除外重大既往症，涵盖一般既往症，限额¥3,000</a-select-option>
                        <a-select-option key="1" value="1.6667">除外重大既往症，涵盖一般既往症，限额¥5,000</a-select-option>
                        <a-select-option key="1" value="2.6667">除外重大既往症，涵盖一般既往症，限额¥8,000</a-select-option>
                        <a-select-option key="1" value="3.3333">除外重大既往症，涵盖一般既往症，限额¥10,000</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                      特殊医疗备注：
                  </a-col>
                  <a-col :span="12" class="bold_lable_">
                    <span class="l_span">
                      1、既往症是指在保险责任生效前，被保险人就已接受诊断、医学咨询或者治疗，或者服用药物，或者显现症状的疾病或损伤。
                    </span>
                  </a-col>
                </a-row>
                <!-- <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >非既往症的慢性疾病:<br />
                    <span class="l_span">
                      慢性疾病和症状指满足下列条件之一的的伤害、疾病或者症状：1.
                      持续接受三个月以上的医学必需的治疗；2.
                      预期病程长久且无可合理预计的康复日期，可能复发、需要连续或者定期护理。
                    </span>
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >非既往症的重大疾病:<br />
                    <span class="l_span">
                      医学必需且合理的有关重大疾病和症状的治疗费。<br />
                      · 重大疾病：<br />
                      1.
                      心血管疾病－包括冠心病、先天性心脏病、心肌梗塞、主动脉瘤。<br />
                      2.
                      神经疾病－包括脑卒中、脑动脉瘤、阿尔茨海默病、帕金森病、脊髓空洞症、多发性硬化症。<br />
                      3.
                      血液疾病－包括白血病、淋巴瘤、再生障碍性贫血、血小板减少性紫癜、血友病。<br />
                      4. 肺部疾病－慢性阻塞性肺病、原发性肺动脉高压。<br />
                      5. 消化疾病－肝硬化、重症肝炎。<br />
                      6.
                      自身免疫性疾病－包括系统性红斑狼疮、系统性硬皮病、获得性免疫缺陷综合症（AIDS，艾滋病）、艾滋相关综合征（ARCS）和其他与
                      HIV 病毒相关的性传染病或者症状。<br />
                      7.其他-恶性肿瘤、良性脑肿瘤、良性脊髓肿瘤、主要器官衰竭或者移植、囊性纤维化、黑斑息肉病、Ⅲ度烧伤。
                    </span>
                  </a-col>
                  <a-col :span="12" class="bold_lable_"> 全额赔付 </a-col>
                </a-row>

                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >先天性疾病:<br />
                    <span class="l_span">
                      先天性疾病和症状：指由于基因因素、先天性新陈代谢异常或者其他因素导致的、出生时即存在的遗传性疾病和症状、出生缺陷、身体残疾、智障等发育不完全正常的疾病和症状，这些疾病和症状可能在出生时显现或者在出生后逐步显现。
                    </span>
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        v-model="item.xiantianJB"
                        @change="(val) => handlePlanChange(val, item)"
                      >
                        <a-select-option key="0" value="0"
                          >不包含</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >全额赔付</a-select-option
                        >
                        <a-select-option key="2" value="2"
                          >20,000</a-select-option
                        >
                        <a-select-option key="3" value="3"
                          >60,000</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_"
                    >艾滋病及并发症费用，不包括既往症:
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select
                        v-model="item.feijiwangAZB"
                        @change="(val) => handlePlanChange(val, item)"
                      >
                        <a-select-option key="0" value="0"
                          >不包含</a-select-option
                        >
                        <a-select-option key="1" value="1"
                          >全额赔付</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                  </a-col> 
                </a-row>-->
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：生育医疗保险金</span>
                <span @click="planDesc[4].unexpand = !planDesc[4].unexpand" class="h_right_">
                  {{ planDesc[4].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[4].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[4].unexpand" class="content_">
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    生育医疗年度限额 :
                    <br />
                    <!-- <span class="l_span">
                      附属被保险子女责任除外 <br />
                      · 不孕不育症的检查、治疗及药物为责任免除 <br />
                      · 对于非自然怀孕的被保险人仅涵盖正常分娩费用。 <br />
                    </span>-->
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.yunchan">
                        <a-select-option key="0" value="0">不附加</a-select-option>
                        <a-select-option key="1" value="1">10,000</a-select-option>
                        <a-select-option key="2" value="2">20,000</a-select-option>
                        <a-select-option key="4" value="3">40,000</a-select-option>
                        <a-select-option key="6" value="4">60,000</a-select-option>
                        <a-select-option key="8" value="5">80,000</a-select-option>
                        <a-select-option key="10" value="6">100,000</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <div class="border_ label_w3_ mrg_" v-if="item.yunchan > 0">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      等待期 :
                      <br />
                      <!-- <span class="l_span">
                        受限于生育总限额 <br />
                        产前、生产时、产后需要接受治疗的、在妊娠以后才出现的疾病，包括但不限于妊娠合并糖尿病、妊娠合并肾病、妊娠合并甲状腺功能亢进、心代偿失调、异位妊娠终止。
                        <br />
                        不孕不育症的检查、治疗、药物和/或与其相关的妊娠并发症为责任免除
                        <br />
                      </span>-->
                    </a-col>
                    <a-col :span="12" class="bold_lable_">10个月</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      生育费用、妊娠并发症治疗费、新生儿护理费和医疗费 :
                      <br />
                      <!-- <span class="l_span">
                        受限于生育总限额 <br />
                        出生后 14 日内的医学必需且合理的护理和医疗费。 <br />
                        此福利仅对于婴儿以附属被保险人的身份没有加入此保险的情况；如果婴儿以被保险人加入此保险，则使用其被保险人自己的福利。
                        <br />
                      </span>-->
                    </a-col>
                    <a-col :span="12" class="bold_lable_">100%赔付</a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      <br />
                      <span class="l_span">
                        生育医疗备注：
                        <br />1、生育费用包括顺产、医疗必须的剖腹产、产前检查和产后检查费用。不孕不育症的检查、治疗及药物为责任免除，对于非自然2、新生儿护理和医疗费，仅限出生后14日内发生的费用
                        <br />
                      </span>
                    </a-col>
                    <a-col :span="12" class="bold_lable_">全额赔付</a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：牙科医疗保险金</span>
                <span @click="planDesc[5].unexpand = !planDesc[5].unexpand" class="h_right_">
                  {{ planDesc[5].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[5].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[5].unexpand" class="content_">
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    牙科医疗年度限额:
                    <br />
                    <!-- <span class="l_span">
                      保单免赔额和自付比例不适用于牙科福利
                    </span>-->
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.chike">
                        <a-select-option key="0" value="0">不附加</a-select-option>
                        <a-select-option key="1" value="0.25">1,000</a-select-option>
                        <a-select-option key="2" value="0.50">2,000</a-select-option>
                        <a-select-option key="3" value="0.75">3,000</a-select-option>
                        <a-select-option key="4" value="1">4,000</a-select-option>
                        <a-select-option key="5" value="1.25">5,000</a-select-option>
                        <a-select-option key="6" value="1.5">6,000</a-select-option>
                        <a-select-option key="7" value="2">8,000</a-select-option>
                        <a-select-option key="8" value="2.25">9,000</a-select-option>
                        <a-select-option key="9" value="2.5">10,000</a-select-option>
                        <a-select-option key="10" value="3">12,000</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>

                <div class="border_ label_w3_ mrg_" v-if="item.chike > 0">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      预防治疗赔付比例:
                      <br />
                      <!-- <span class="l_span">
                        不受限于牙科年免赔额<br />
                        必要的诊断检查及预防治疗，X光片，洁齿，涂氟治疗（限19周岁以下），窝沟封闭
                      </span>-->
                    </a-col>
                    <a-col :span="12" class="bold_lable_">100%赔付</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      基础治疗赔付比例:
                      <br />
                      <!-- <span class="l_span">
                        基础修复，简单拔牙，牙周治疗，根管治疗以及口腔外科手术
                      </span>-->
                    </a-col>
                    <a-col :span="12">80% 赔付</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      重大治疗赔付比例:
                      <br />
                      <!-- <span class="l_span">
                        牙冠，嵌体，桥式义齿及智齿拔除。承担的费用包括必要的医生安装或更换用品费用及服务费
                      </span>-->
                    </a-col>
                    <a-col :span="12">50% 赔付</a-col>
                  </a-row>
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      正畸治疗（允许的被保险人最高年龄至19周岁）:
                      <br />
                      <span class="l_span">包括：模型研究（包括口腔X光片），牙齿印模，矫正所需拔牙和托槽粘接</span>
                    </a-col>
                    <a-col :span="12">50% 赔付</a-col>
                  </a-row>

                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      牙科医疗备注：
                    </a-col>
                    <a-col :span="12">
                      <span class="l_span">
                        1、预防治疗是指：1.包括常规牙科检查、医生问诊、口腔档案建立、牙齿健康指导、儿童刷牙指导及口腔护理指导、口腔全景片、小牙片、涂氟治疗、洁齿和抛光（预防性）、牙齿清洁检查（限两次）、口腔涂氟（19岁以下，限一次）、窝沟封闭（限一次）等。
                        <br />2、基础治疗是指：包括汞合金或复合树脂充填、简单拔牙、牙周刮治、根面平整、多生牙及乳牙拔除、龋齿补牙及填充术、根管治疗及预成冠，以及相关口腔X光等；
                        <br />3、重大治疗是指：包括牙冠、桥式义齿（包括化验和麻醉费）、智齿拔除、，以及相关口腔X光等。
                        <br />4、常见责任免除项目：（1）美容手术或设备或治疗；（2）正畸，肌功能矫正；（3）不符合通常标准的服务和设备；（4）实验性治疗和非医疗必须的治疗；（5）种植牙及所有相关服务；（6）假牙；（7）防护牙托或其他磨牙相关服务
                        <br />
                      </span>
                    </a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：预防性检查</span>
                <span @click="planDesc[6].unexpand = !planDesc[6].unexpand" class="h_right_">
                  {{ planDesc[6].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[6].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[6].unexpand" class="content_">
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    预防性检查费年度限额 ：
                    <br />
                    <!-- <span class="l_span">
                      · 预防性检查或健康体检的合理费用，包括医生费，如： <br />
                      · 每年一次的常规体检、测试。 <br />
                      · 合理的常规疫苗接种费，旅行疫苗除外。
                    </span>-->
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.tijian">
                        <a-select-option key="0" value="0">不附加</a-select-option>
                        <a-select-option key="1" value="0.25">1,000</a-select-option>
                        <a-select-option key="2" value="0.5">2,000</a-select-option>
                        <a-select-option key="3" value="0.75">3,000</a-select-option>
                        <a-select-option key="2" value="1">4,000</a-select-option>
                        <a-select-option key="2" value="1.25">5,000</a-select-option>
                        <a-select-option key="2" value="2.50">10,000</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div v-if="item.tijian > 0">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      常规体检、成年女性、男性特定筛查费、家族病史筛查费、儿童疫苗注射：
                      <br />
                    </a-col>
                    <a-col :span="12">100%赔付</a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <div class="plan_section_">
              <div class="header_">
                <span>可选：眼科医疗保险金</span>
                <span @click="planDesc[7].unexpand = !planDesc[7].unexpand" class="h_right_">
                  {{ planDesc[7].unexpand ? "展开" : "收起" }}
                  <a-icon :type="planDesc[7].unexpand ? 'down' : 'up'"></a-icon>
                </span>
              </div>
              <div v-if="!planDesc[7].unexpand" class="content_">
                <a-row :span="24" class="table_item">
                  <a-col :span="12" class="bold_lable_">
                    眼科医疗年度限额 ：
                    <br />
                    <!-- 镜框 （每保单年度仅限一次） ： <br />
                    镜片（每保单年度可选以下任一项配一副）<br />
                    · 单焦 <br />
                    · 双焦 <br />
                    · 三焦 <br />
                    · 隐形眼镜（1盒）-->
                  </a-col>
                  <a-col :span="12">
                    <a-form-item class="bold_lable_">
                      <a-select @change="handleCalcPlanPremium(item)" v-model="item.yanke">
                        <a-select-option key="0" value="0">不附加</a-select-option>
                        <a-select-option key="1" value="1">1,000</a-select-option>
                      </a-select>
                    </a-form-item>
                  </a-col>
                </a-row>
                <div v-if="item.yanke > 0">
                  <a-row :span="24" class="table_item">
                    <a-col :span="12" class="bold_lable_">
                      视力检查费、矫正镜片、镜框和隐形眼镜所产生的费用
                      <br />
                    </a-col>
                    <a-col :span="12">100%赔付</a-col>
                  </a-row>
                </div>
              </div>
            </div>
            <a-form-item class="bold_lable_ mrg_t12_" label="投保人数"></a-form-item>
            <a-row class="t_header_" :gutter="8">
              <a-col :span="6">年龄</a-col>
              <a-col :span="6">费率</a-col>
              <a-col :span="6">人数</a-col>
              <a-col :span="6">预估员工平均年龄</a-col>
            </a-row>
            <a-row v-for="(p, index) in item.insuredList" class="t_td_" :gutter="8">
              <a-col :span="6">
                <span>
                  {{ ageOptions[p.age]
                  }}{{ ageOptions[p.age] == "65-70" ? "*" : "" }}
                </span>
              </a-col>
              <a-col :span="6">
                <span>{{ p.basicCale }}</span>
              </a-col>
              <a-col :span="6">
                <a-input
                  v-model="p.num"
                  @change="averageAge(p, item)"
                  @blur="handleCalcPlanPremium(item)"
                  placeholder="请输入"
                ></a-input>
              </a-col>
              <a-col :span="6">
                <span>{{ ageOptions[p.age].split("-")[1] }}</span>
              </a-col>
            </a-row>
            <a-row class="t_td_ t_footer_" :gutter="8">
              <a-col :span="6">合计</a-col>
              <a-col :span="6">{{ item.basicPlanPremium | filterNumber }}元</a-col>
              <a-col :span="6">{{ item.insuredTotalNum }}人</a-col>
              <a-col :span="6">{{ item.aveAgeNum }}</a-col>
            </a-row>
            <a-row
              class="t_td_"
              :gutter="8"
              style="text-align: left; color: red; line-height: 20px"
            >
              *65岁及以上仅限续保
              <br />*投保团体的被保险人员工总人数少于5人时，为无效报价；
              <br />*投保团体的被保险人员工预估平均年龄超过50周岁时，报价书仅供参考；
            </a-row>
            <!-- <a-row class="t_header_" :gutter="8">
              <a-col :span="8"> 可选保障 </a-col>
              <a-col :span="8"> 成人费率 </a-col>
              <a-col :span="8"> 儿童费率 </a-col>
            </a-row>
            <a-row
              v-for="(p, index) in item.quotationInsuredListOpt"
              class="t_td_"
              :gutter="8"
            >
              <a-col :span="8">
                <span>{{ p.name }}</span>
              </a-col>
              <a-col :span="8">
                <span>{{ p.adultPremium | filterNumber }}</span>
              </a-col>
              <a-col :span="8">
                <span>{{ p.childPremium | filterNumber }}</span>
              </a-col>
            </a-row>
            <a-row class="t_td_ t_footer_" :gutter="8">
              <a-col :span="10"> 该保障计划总保费 </a-col>
              <a-col :span="14"> {{ item.premiumS }}元 </a-col>
            </a-row>-->
          </a-form>
          <!-- 最多新增3个 -->
          <div
            v-if="index == planList.length - 1 && edit && planList.length < 3"
            @click="handleAddPlan"
            class="btn_add_"
          >
            <a-icon type="plus"></a-icon>新增保障计划
          </div>
        </div>
      </div>

      <a-form class="horizontal_item_ label_w1_">
        <a-form-item label="保费调整比例">
          <a-select
            v-model="addPercent"
            style="width: 300px"
            placeholder="请选择保费调整比例"
            @change="(val) => addPercentBlur(val)"
          >
            <a-select-option key="0" value="1">100%</a-select-option>
            <a-select-option key="1" value="1.05">105%</a-select-option>
            <a-select-option key="1" value="1.10">110%</a-select-option>
            <a-select-option key="1" value="1.15">115%</a-select-option>
            <a-select-option key="1" value="1.20">120%</a-select-option>
            <a-select-option key="1" value="1.25">125%</a-select-option>
            <a-select-option key="1" value="1.30">130%</a-select-option>
            <a-select-option key="1" value="1.35">135%</a-select-option>
            <a-select-option key="1" value="1.40">140%</a-select-option>
            <a-select-option key="1" value="1.45">145%</a-select-option>
            <a-select-option key="1" value="1.50">150%</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="总保费">
          <a-input
            style="width: 300px"
            :readonly="true"
            v-model="aallTotalPremium"
            placeholder="总保费"
          ></a-input>
        </a-form-item>
      </a-form>

      <!-- <div class="box_">
        <p>
          如员工人数为5-19，可选择：承担一般既往症，除外重大既往症条件承保，保费将有相应调整。
        </p>
        <div
          class="check_label"
          :class="{ on: checkflag == true, checked: this.addjwz == true }"
          @click="checkAdd"
        >
          <label for=""></label>
          <span>承担一般既往症，除外重大既往症条件承保</span>
        </div>
      </div>-->
      <div class="title_ bold_">保司品牌选择</div>
      <a-form class="horizontal_item_">
        <a-form-item label="优先承保保司选择">
          <a-select v-model="formInfo.companyId" default-value="0">
            <a-select-option
              v-for="itemc in companyList"
              :key="itemc.value"
              :value="itemc.value"
            >{{ itemc.text }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="销售人员名称" v-if="ifShowYj">
          <a-input v-model="formInfo.saleName" placeholder="请输入销售人员名称"></a-input>
        </a-form-item>
        <a-form-item label="佣金比例" v-if="ifShowYj">
          <a-select v-model="formInfo.YjRate" default-value="10" @change="changeYj()">
            <a-select-option
              v-for="itemc in YjRateList"
              :key="itemc.value"
              :value="itemc.value"
            >{{ itemc.text }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="渠道名称" v-if="ifShowYj">
          <a-input v-model="formInfo.channelName" placeholder="请输入渠道名称"></a-input>
        </a-form-item>
      </a-form>
      <p>
        ①上海人寿仅限承保上海地区客户；<br />
        ②利宝可承接北京、广东、浙江、川渝客户以及其他地区40万以上客户；<br />
        ③天安可承接上海客户，及非上海地区40万以上客户； <br />
        ④都邦可承接全国客户；
      </p>
      <p>实际承保与否须经保险公司确认。</p>
      <productIntro></productIntro>
      <div class="footer_">
        <a-checkbox
          @change="(e) => changeCheck(e)"
          :checked="agreed"
          class="checkbox_ blue_checkbox_"
        ></a-checkbox>我已阅读并知晓投保须知及《保险条款》内容
        <div style="color: red">不符合线上报价条件的，请联系您的中间带客户经理</div>
        <div>
          <button @click="handleToPreview" class="btn_">生成报价书</button>
        </div>
      </div>
    </div>
    <div class="fixbg1" v-if="isLoagding">
      <a-spin />
    </div>
    <div class="fix_btn" v-if="ifShowYj" @click="showSearch = true">询价查询</div>
    <div class="fix_btn" v-if="ifShowYj" style="top: 45vh;" @click="showSearchQuery = true">客户查询</div>
    <div class="search_" v-if="showSearch">
      <div class="con_">
        <p>查询报价信息</p>
        <span class="close_btn" @click="showSearch = false"></span>
        <div class="top_">
          <a-input v-model="searchKey" placeholder="请输入客户名称"></a-input>
        </div>
        <div class="button">
          <button @click="searchName">查询</button>
        </div>
        <div class="content_" v-if="showReturn && fetchData">
          <p>询价单号：{{ fetchData.id }}</p>
          <p>客户名称：{{ fetchData.phName }}</p>
          <p>销售人员名称：{{ fetchData.webCustomerName }}</p>
          <p>生效日期：{{ fetchData.effectiveDate }}</p>
          <p>
            报价书链接：
            <a :href="fetchData.offerLetter">点击查看</a>
          </p>
        </div>
      </div>
    </div>
    <!-- SSI-4569改为客服名称下提示 -->
    <!-- <a-modal v-model="nameMoadl" title="Basic Modal">
      <p style="word-break: break-all;">该客户不支持线上报价，请发送询价信息至mg-uw@medilink-global.com.cn</p>
      <template #footer>
        <a-button key="submit" type="primary" @click="copyUrl">确认并复制邮箱地址</a-button>
      </template>
    </a-modal> -->
    <customerQuery :showSearch="showSearchQuery" 
      :close="()=>{showSearchQuery = false}"
    />
  </div>
</template>
<style>
.ant-select-dropdown-content .ant-select-dropdown-menu-item {
  white-space: normal;
}
</style>
<style lang="scss" scoped>
.error-name {
  font-size: 12px;
  line-height: 20px;
  color: red;
  margin: 0;
  margin-left: 6rem;
}
.table_ {
  border-color: #eee;
  border: 1px solid #eee;
  width: 100%;
  table-layout: fixed;

  .center_ {
    text-align: center;
  }

  td {
    border: 1px solid #eee;

    &:nth-child(2n + 1) {
      color: #333;
      font-weight: bold;
      padding-left: 12px;
    }

    &:nth-child(2n) {
      text-align: center;
    }
  }
}

.plan_section_ {
  margin: 12px 0;
  color: #6e6e6e;
  border-radius: 16px;
  box-shadow: 0rem 0rem 6px 0rem rgba(96, 130, 253, 0.47);
  overflow: hidden;

  .header_ {
    line-height: 30px;
    display: flex;
    justify-content: space-between;
    background: linear-gradient(to bottom, #92a9fc 0%, #6284fe 100%);
    font-size: 14px;
    padding: 12px;
    color: #fff;

    .h_right_ {
      font-size: 12px;
    }
  }

  .pre_ {
    white-space: pre-wrap;
  }

  .content_ {
    margin: 12px;
    font-size: 12px;
  }

  .flex_row_ {
    display: flex;
    align-items: center;
  }

  .place_ {
    visibility: hidden;
  }

  .lh37_ {
    line-height: 36px;
  }

  .left_ {
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
    padding-left: 6px;
    color: #333;
    font-weight: bold;
  }

  .right_ {
    text-align: center;
    border-right: 1px solid #eee;
    border-bottom: 1px solid #eee;
  }

  .line_h_ {
    line-height: 50px;
  }
}

.page_ {
  max-width: 1280px;
  margin: 0 auto;

  .p_content_ {
    padding: 0 12px;
  }

  .banner_ {
    width: 100%;
    height: auto;
    margin-bottom: 12px;
  }

  .footer_ {
    margin-top: 16px;
    padding-bottom: 50px;

    .checkbox_ {
      margin-right: 6px;
    }

    .btn_ {
      background-color: rgb(24, 144, 255);
      border: none;
      color: #fff;
      margin-top: 8px;
      line-height: 28px;
      border-radius: 6px;

      &:focus {
        outline: none;
      }
    }
  }

  .border_ {
    border: 1px solid #eee;
    padding: 6px;
    border-radius: 12px;

    &.mrg_ {
      margin: 12px 0;
    }
  }

  .mrg_t12_ {
    margin-top: 12px;
  }

  .top_ {
    margin-bottom: 8px;
  }

  .title_ {
    border-left: 3px solid rgb(61, 94, 213);
    padding-left: 6px;
    margin: 18px 0 8px;
  }

  .s_title_ {
    line-height: 32px;
    background-color: rgb(61, 94, 213);
    color: #fff;
    border-radius: 12rpx;
    text-align: center;
    position: relative;

    .left_ {
      position: absolute;
      left: 24px;
      top: 50%;
      transform: translateY(-50%);
    }

    .right_ {
      position: absolute;
      right: 12px;
      font-size: 12px;
    }
  }

  .section_ {
    margin-top: 12px;

    .form_ {
      border: 1px solid #eee;
      padding: 8px;
    }

    .t_header_ {
      text-align: center;
      margin-bottom: 6px;
    }

    .t_td_ {
      text-align: center;
      line-height: 32px;
      margin-bottom: 8px;

      &.t_footer_ {
        font-weight: 500;
        color: rgb(61, 94, 213);
      }
    }
  }

  .btn_add_ {
    margin: 8px 0;
    color: rgb(61, 94, 213);
    text-decoration: underline;
    font-size: 12px;
  }
}

.fixbg1 {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 99999;
  right: 0;
  background-color: rgba(255, 255, 255, 0.5);

  .ant-spin-spinning {
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    left: 0;
    margin: auto;
  }
}

.check_label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #999;

  label {
    width: 18px;
    height: 18px;
    border: 1px solid #d9d9d9;
    display: inline-block;
    margin-right: 5px;
    background-color: #999;
  }

  &.on {
    color: #333;

    label {
      background-color: #fff;
    }
  }

  &.checked {
    label {
      background: url(../../assets/quote/checkiconr.png) center center no-repeat
        #3d5ed5;
      background-size: 15px 15px;
      border-color: #3d5ed5;
    }
  }
}

.search_ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 5;

  .con_ {
    background-color: #fff;
    width: 90%;
    border-radius: 15px;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    transform: translateY(-50%);
    padding: 10px 15px 20px;

    .close_btn {
      position: absolute;
      top: 10px;
      right: 10px;
      display: block;
      width: 25px;
      height: 25px;
      background: url(../../assets/quote/closeicon.png) center center no-repeat;
      background-size: 25px 25px;
    }

    > p {
      padding: 10px;
      text-align: center;
      font-weight: bold;
    }

    .button {
      margin-top: 15px;
    }

    button {
      width: 100px;
      background-color: #3d5ed5;
      border: none;
      outline: 0;
      color: #fff;
      display: block;
      margin: 20px auto 0;
      padding: 5px 0;
      border-radius: 5px;
    }

    .content_ {
      padding: 5px 0;
      margin-top: 10px;
      overflow: hidden;
      overflow-y: scroll;

      p {
        margin-bottom: 0;
      }

      a {
        color: #3d5ed5;
      }
    }
  }
}

.fix_btn {
  position: fixed;
  right: 0;
  top: 30vh;
  z-index: 3;
  writing-mode: vertical-rl;
  background-color: #3d5ed5;
  color: #fff;
  display: block;
  text-align: center;
  padding: 15px 8px;
  border-radius: 5px;
  line-height: 20px;
  cursor: pointer;
}

.table_item .bold_lable_:nth-of-type(n + 2) {
  text-align: left;
}
</style>
<script>
import productIntro from "./components/productIntro1";
import dutyIntro from "./components/dutyIntro";
import api from "@/utils/api";
import wxAbout from "@/utils/wxAbout";
import moment from "moment";
import customerQuery from "./components/customerQuery";
const ageOptions = [
  "0-6",
  "7-17",
  "18-24",
  "25-29",
  "30-34",
  "35-39",
  "40-44",
  "45-49",
  "50-54",
  "55-59",
  "60-64",
  "65-70"
];
const premiumRules = [
  //住院基准毛保费
  [2294, 2493, 2527, 2647, 2695, 2729, 2743, 2753, 3388, 3576, 6479],
  [1655, 2051, 2078, 2177, 2217, 2245, 2257, 2264, 2403, 2537, 4386],
  [2027, 2115, 2144, 2246, 2286, 2315, 2327, 2335, 3030, 3199, 4441],
  [1941, 2198, 2228, 2334, 2376, 2406, 2418, 2427, 3357, 3544, 4558],
  [2272, 2253, 2283, 2392, 2435, 2466, 2479, 2488, 3658, 3862, 5429],
  [2830, 2650, 2685, 2813, 2864, 2900, 2915, 2926, 4375, 4618, 6348],
  [4207, 3203, 3246, 3401, 3462, 3506, 3524, 3537, 4967, 5243, 6990],
  [5497, 3714, 3764, 3943, 4015, 4065, 4086, 4101, 5777, 6099, 8111],
  [7465, 4630, 4693, 4916, 5006, 5068, 5095, 5113, 7246, 7649, 10577],
  [10088, 5349, 5422, 5680, 5783, 5855, 5886, 5907, 9456, 9982, 13882],
  [14210, 6037, 6119, 6410, 6527, 6608, 6643, 6667, 11990, 12656, 17947],
  [20430, 7958, 8066, 8450, 8603, 8711, 8757, 8788, 15521, 17587, 22913]
];
const mzpremiumRules = [
  //门诊保费基准毛保费
  [10578, 2493, 2527, 2647, 2695, 2729, 2743, 2753, 3388, 3576, 6479],
  [7096, 2051, 2078, 2177, 2217, 2245, 2257, 2264, 2403, 2537, 4386],
  [8676, 2115, 2144, 2246, 2286, 2315, 2327, 2335, 3030, 3199, 4441],
  [10869, 2198, 2228, 2334, 2376, 2406, 2418, 2427, 3357, 3544, 4558],
  [10800, 2253, 2283, 2392, 2435, 2466, 2479, 2488, 3658, 3862, 5429],
  [10729, 2650, 2685, 2813, 2864, 2900, 2915, 2926, 4375, 4618, 6348],
  [11697, 3203, 3246, 3401, 3462, 3506, 3524, 3537, 4967, 5243, 6990],
  [12571, 3714, 3764, 3943, 4015, 4065, 4086, 4101, 5777, 6099, 8111],
  [14488, 4630, 4693, 4916, 5006, 5068, 5095, 5113, 7246, 7649, 10577],
  [17996, 5349, 5422, 5680, 5783, 5855, 5886, 5907, 9456, 9982, 13882],
  [21415, 6037, 6119, 6410, 6527, 6608, 6643, 6667, 11990, 12656, 17947],
  [27614, 7958, 8066, 8450, 8603, 8711, 8757, 8788, 15521, 17587, 22913]
];
const dlyypremiumRules = [
  //地理/医院涵盖范围
  [0.9, 1, 1.05, 1.2, 1.4],
  [0, 1.12, 1.17, 1.34, 1.56],
  [0, 1.2, 1.25, 1.44, 1.68],
  [0, 1.84, 1.88, 2.02, 2.2],
  [0, 2, 2.05, 2.2, 2.4]
];
const sscwpremiumRules = [
  //膳食费+床位费
  [1, 1.0224, 1.0327, 1.0415, 1.0475, 1.0522],
  [0.9672, 1, 1.0149, 1.0289, 1.0462, 1.0591],
  [0.9376, 0.9598, 0.9752, 1, 1.0442, 1.0871],
  [0.9146, 0.9321, 0.9444, 0.9636, 1, 1.0742],
  [0.8447, 0.8581, 0.8677, 0.8829, 0.9108, 1]
];
const ysfwpremiumRules = [
  //医生费
  [1.0405, 0.8913, 0.9726, 1, 1.0282, 1.0362, 1.038, 1.0388, 1.0393],
  [1.032, 0.8326, 0.9218, 0.956, 1, 1.0179, 1.0249, 1.0284, 1.0298],
  [1.0041, 0.7905, 0.8938, 0.9363, 0.9861, 1, 1.0027, 1.0032, 1.0034],
  [1.0085, 0.7526, 0.8345, 0.8734, 0.9404, 0.9826, 1, 1.0067, 1.0076],
  [1, 0.7215, 0.7873, 0.8196, 0.8807, 0.9325, 0.9684, 0.9916, 0.9986]
];
const synxpremiumRules = [
  //生育医疗年度限额
  [0, 0.4551, 0.6053, 0.8128, 0.9308, 1, 1.0365],
  [0, 0.3894, 0.5382, 0.7478, 0.8996, 1, 1.0444],
  [0, 0.3475, 0.5017, 0.7386, 0.8937, 1, 1.0499],
  [0, 0.3248, 0.4714, 0.9834, 0.8678, 1, 1.0768],
  [0, 0.2818, 0.4193, 0.6034, 0.7588, 0.8984, 1]
];
// 牙科
const dentalPremiumRules = [
  [806, 1627, 3047],
  [1151, 2324, 4352]
];
// 体检
const preventivePremiumRules = [
  [1682, 2355],
  [2243, 3140]
];
// 孕产
const maternityPremiumRules = [1838, 3492, 3400, 6460];
// 眼科
const eyesPremiumRules = [827, 1736];
export default {
  data() {
    document.title = "MediLink-Global中端小团体医疗保险报价器";
    console.log("data -> ", this.$route);
    const edit = this.initStatus(); // 刷新时
    return {
      planDesc: [
        { unexpand: false },
        { unexpand: true },
        { unexpand: true },
        { unexpand: true },
        { unexpand: true },
        { unexpand: true },
        { unexpand: true },
        { unexpand: true }
      ],
      edit, // 编辑还是预览
      addPercent: "1",
      ageOptions,
      NumAgeObj: {}, //选的年龄人数
      mzBZ: undefined,
      allTotalPremium: "0", //总保费
      aallTotalPremium: "0", //总保费（加费）
      planList: [
        {
          aveAgeNum: 0, //平均年龄
          amount: "500000", // 基础保障保额
          menzhenLimit: "0", // 可选保障计划索引
          mzmpe: "1", // 门诊免赔额
          yishiUpgrade: "0", // 医师诊疗跟专家门诊
          liliaoUpgrade: "0",
          extHospital: "0", // 医院列表索引
          zymbe: "0", // 住院免赔额
          zhongyiUpgrade: "0", // 中医额度增加800/次
          zhuyuan: "0", // 食宿费
          tsjwz: "0", // 既往症
          chike: "0",
          tijian: "0",
          yunchan: "0",
          emergencyMedical: "0",
          jjylndxe: "1",
          mzBZ: "0",
          premium: 0,
          outAreaMedical: "0",
          insuredTotalNum: 0,
          basicPlanPremium: 0,
          insuredList: [
            { age: 0, basicCale: "2,406 " },
            { age: 1, basicCale: "1,979 " },
            { age: 2, basicCale: "2,041" },
            { age: 3, basicCale: "2,121" },
            { age: 4, basicCale: "2,174" },
            { age: 5, basicCale: "2,557" },
            { age: 6, basicCale: "3,091" },
            { age: 7, basicCale: "3,584" },
            { age: 8, basicCale: "4,469" },
            { age: 9, basicCale: "5,163" },
            { age: 10, basicCale: "5,827" },
            { age: 11, basicCale: " 7,681" }
          ],
          areaCoverage: "0",
          zhfs: "1",
          cbtj: "1",
          waitDay: "0",
          mzJingshen: "0",
          hosJS: "0",
          hosLZ: "0",
          mzLZ: "0",
          hosZL: "0",
          wlpZYJT: "0",
          fydJTBT: "0",
          shaichaFL: "0",
          teshuZL: "0",
          yanke: "0",
          chuantongZY: "0",
          jjYK: "0",
          shaicha45: "0",
          shaichaYE1: "0",
          shaichaYE0_7: "0",
          shaichaJZBS: "0",
          xiantianJB: "0",
          feijiwangAZB: "0",
          shuimianJC: "0",
          jiatingHL: "0",
          quotationInsuredListOpt: [
            {
              name: "可选孕产保障",
              coverage: "0",
              adultCount: 0,
              adultPremium: "0",
              childCount: 0,
              childPremium: "0",
              total: "0"
            },
            {
              name: "可选齿科保障",
              coverage: "0",
              adultCount: 0,
              adultPremium: "0",
              childCount: 0,
              childPremium: "0",
              total: "0"
            },
            {
              name: "可选体检保障",
              coverage: "0",
              adultCount: 0,
              adultPremium: "0",
              childCount: 0,
              childPremium: "0",
              total: "0"
            },
            {
              name: "可选眼科保障",
              coverage: "0",
              adultCount: 0,
              adultPremium: "0",
              childCount: 0,
              childPremium: "0",
              total: "0"
            }
          ]
        }
      ],
      formInfo: {
        companyId: "0",
        YjRate: "15",
        saleName: "",
        channelName: ""
      },
      agreed: false,
      planValueOptions: [
        {
          name: "0",
          value: "0"
        },
        {
          name: "1万",
          value: "0.6318"
        },
        {
          name: "2万",
          value: "0.8469"
        },
        {
          name: "3万",
          value: "0.9374"
        },
        {
          name: "4万",
          value: "0.9785"
        },
        {
          name: "5万",
          value: "1"
        },
        {
          name: "6万",
          value: "1.0122"
        },
        {
          name: "8万",
          value: "1.0257"
        },
        {
          name: "10万",
          value: "1.0322"
        },
        {
          name: "全额赔付",
          value: "1.0530"
        }
      ],
      companyList: [
        {
          value: "1",
          text: "天安财险保险股份有限公司"
        },
        {
          value: "3",
          text: "都邦财产保险股份有限公司"
        },
        {
          value: "0",
          text: "利宝保险有限公司"
        },
        {
          value: "2",
          text: "上海人寿保险股份有限公司"
        }
      ],
      isLoagding: false,
      userId: "",
      checkflag: false,
      people18Num: 0,
      addjwz: false,
      ifShowYj: false,
      YjRateList: [
        {
          value: "10",
          text: "10%"
        },
        {
          value: "12",
          text: "12%"
        },
        {
          value: "15",
          text: "15%"
        },
        {
          value: "18",
          text: "18%"
        },
        {
          value: "20",
          text: "20%"
        }
      ],
      searchKey: "",
      showSearch: false,
      showSearchQuery: false,
      showReturn: false,
      columns: [
        {
          title: "编号",
          dataIndex: "key"
        },
        {
          title: "销售人员",
          dataIndex: "webCustomerName"
        },
        {
          title: "客户名称",
          dataIndex: "phName"
        },
        {
          title: "生效日期",
          dataIndex: "effectiveDat"
        },
        {
          title: "佣金",
          dataIndex: "agentRate"
        },
        {
          title: "计划书",
          scopedSlots: { customRender: "pdf" }
        }
      ],
      originList: [],
      tableList: [],
      fetchData: {},
      ifnvs: "2", //是否是内部版本标志，为1时为内部版本
      isValidName: false, // 是否为合法的客户名称
      errTip: "", // 客户名称提示信息
      prohibitedIndustries: ["学校", "幼儿园", "小学", "中学", "大学", "律师"], //限制行业
      nameMoadl: false //提示框控制变量
    };
  },
  watch: {
    $route: function() {
      this.edit = this.initStatus(); // 非刷新时
    }
  },

  components: {
    productIntro,
    customerQuery,
    dutyIntro
  },
  filters: {
    filterCompany(val, options) {
      if (val) {
        return options.filter(item => item.value == val)[0].text;
      } else {
        return val;
      }
    },
    filterNumber: val => {
      if (val) {
        let val_ = (val || 0).toString(),
          result = "";
        while (val_.length > 3) {
          result = "," + val_.slice(-3) + result;
          val_ = val_.slice(0, val_.length - 3);
        }
        if (val_) {
          result = val_ + result;
        }
        return result;
      } else {
        return val;
      }
    }
  },
  mounted() {
    const { userId, nvs } = this.$route.query;
    this.userId = userId;
    this.ifnvs = nvs || "2";
	console.log(this.ifnvs,nvs,'哈哈哈哈')
    this.CPStrack();
    if (this.ifnvs == "1") {
      this.ifShowYj = true;
    }
  },
  methods: {
    moment,
    averageAge(val, item) {
      let ageText = ageOptions[val.age].split("-")[1];
      let AGEResult = 0;
      let allNum = 0;
      if (val.num && ageText >= 18) {
        this.NumAgeObj[ageText] = val.num;
      } else {
        delete this.NumAgeObj[ageText];
      }
      Object.keys(this.NumAgeObj).forEach(e => {
        AGEResult += e * parseInt(this.NumAgeObj[e]);
        allNum += parseInt(this.NumAgeObj[e]);
      });
      if (allNum) {
        let a = (AGEResult / allNum).toFixed(1);
        item["aveAgeNum"] = a;
      }
    },
    copyUrl() {
      let copyInput = document.createElement("input"); //创建input元素
      document.body.appendChild(copyInput); //向页面底部追加输入框
      copyInput.style.cssText = "position: fixed;top:-9999px";
      copyInput.setAttribute("value", "mg-uw@medilink-global.com.cn"); //添加属性，将url赋值给input元素的value属性
      copyInput.select(); //选择input元素
      document.execCommand("Copy"); //执行复制命令
      this.nameMoadl = false;
    },
    // 校验用户名
    checkName() {
      this.isValidName = false;
      // if (this.ifnvs != "1") {
      let valid = this.prohibitedIndustries.every(element => {
        if (this.formInfo.name && this.formInfo.name.indexOf(element) != -1) {
          this.errTip = "本报价工具不适用学校、律所报价！";
          this.$message.error(`本报价工具不适用学校、律所报价！`);
          this.formInfo.name = "";
          return false;
        } else {
          return true;
        }
      });
      if (!valid) return;
      let params = {
        name: this.formInfo.name,
        pageSource: "outer"
      };
      api
        .validCustomerName(params)
        .then(res => {
          if (res.data.returnCode === "0") {
            this.isValidName = true;
            return;
          }
        })
        .catch(res => {
          if (res.data.returnCode === "9999") {
            this.errTip = "该客户不支持线上报价，请发送询价信息至mg-uw@medilink-global.com.cn";
          } else {
            this.errTip = res.data.returnMsg;
          }
        });
      // }
    },
    CPStrack() {
      let data = {
        event: "insure_quotation",
        userId: this.userId,
        productCode: "medilink",
        quotationId: ""
      };
      console.log(data, "--->");
      api.CPStrack(data).then(res => {
        let obj = {
          ...res.data.data,
          platform_name: "cps"
        };
        this.track("insure_quotation", obj);
      });
    },
    handleSubPlan(index) {
      this.planList.splice(index, 1);
    },
    initShare(edit) {
      const options = {
        title: `MediLink-Global中端小团体医疗保险报价${edit ? "器" : "书"}`, // 分享标题
        desc: (this.formInfo && this.formInfo.name) || "",
        link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: `${location.origin}/pcmall/img/1.jpeg`, // 分享图标
        success: function() {
          // 设置成功
        }
      };
      wxAbout.fetchJsSdkSign("wxShare", options);
    },
    collectData(arr, report) {
      this.summaryReport = this.summaryReport || [];
      this.summaryReport.push(arr.join(" "));
      if (report) {
        console.group(this.summaryReport.join(";\n"));
        this.summaryReport = [];
      }
    },
    addPercentBlur(value) {
      let allTotalPremium = this.allTotalPremium * Number(value);
      this.aallTotalPremium = Math.ceil(allTotalPremium);
    },
    calcPremium(params = {}, formInfo = {}, all_num) {
      let syjzPremium = 3916; //生育基准保费
      let tsylPremium = 1500; //特殊医疗基准保费
      let yfxjcPremium = 3000; //预防性检查基准保费
      let yankPremium = 691; //眼科基准保费
      let yakPremium = 2400; //牙科基准保费
      let ztValue = 1; //整体调整因子
      let {
        amount, // 基础保障保额
        menzhenLimit, // 可选保障计划索引
        mzmpe, // 门诊免赔额
        yishiUpgrade, // 医师诊疗跟专家门诊
        liliaoUpgrade,
        extHospital, // 医院列表索引
        zhongyiUpgrade, // 中医额度增加800/次
        zhuyuan, // 食宿费
        emergencyMedical,
        mzBZ,
        yunchan,
        outAreaMedical, //区域外紧急医疗
        areaCoverage, //保障地理范围
        waitDay,
        mzJingshen,
        hosJS,
        hosLZ,
        mzLZ,
        hosZL,
        wlpZYJT,
        fydJTBT,
        shaichaFL,
        teshuZL,
        tsjwz, //既往症
        tijian, //体检年限
        yanke, //眼科
        chuantongZY,
        jjYK,
        shaicha45,
        shaichaYE1,
        shaichaYE0_7,
        shaichaJZBS,
        xiantianJB,
        feijiwangAZB,
        shuimianJC,
        jiatingHL,
        zymbe,
        chike,
        jjylndxe
      } = formInfo;
      const { age = 0 } = params; // 此处age为年龄段的索引
      const row = premiumRules[age];
      const mzrow = mzpremiumRules[age];
      let index = 0;
      const aValue = amount;
      // 如果计划不附加
      if (menzhenLimit == 0) {
        menzhenLimit = "0";
        mzmpe = "1";
        yishiUpgrade = "0";
        zhongyiUpgrade = "0";
        liliaoUpgrade = "0";
        mzJingshen = "0";
        mzLZ = "0";
        chuantongZY = "0";
        jiatingHL = "0";
        jjYK = "0";
        shuimianJC = "0";
      }
      let value = row[index]; //住院基准毛保费
      let mzvalue = mzrow[index]; //门诊基准毛保费
      var waitDayVlaue; //等待期系数
      var zhuyuanVlaue; //食宿费系数
      var hosJSVlaue; //住院精神和心理疾病系数
      var amountValue; //最高保额系数
      var zymbeValue; //住院免赔额系数
      var dlyyVlaue = dlyypremiumRules[areaCoverage][extHospital]; //地理/医院涵盖范围系数
      var zhuyuanValue = sscwpremiumRules[extHospital][zhuyuan]; //膳食费+床位费系数
      var yishiUpgradeValue = ysfwpremiumRules[extHospital][yishiUpgrade]; //医生费系数
      var yunchanValue = synxpremiumRules[extHospital][yunchan]; //生育年限系数
      let initValue = value;
      // 最高保额
      switch (amount) {
        case "500000":
          amountValue = 0.98;
          break;
        case "1000000":
          amountValue = 0.985;
          break;
        case "1000000":
          amountValue = 0.985;
          break;
        case "2000000":
          amountValue = 0.99;
          break;
        case "3000000":
          amountValue = 1;
          break;
        case "5000000":
          amountValue = 1.01;
          break;
        case "8000000":
          amountValue = 1.02;
          break;
        case "10000000":
          amountValue = 1.03;
          break;
        case "12000000":
          amountValue = 1.04;
          break;
        case "20000000":
          amountValue = 1.05;
          break;
        default:
          break;
      }
      // 住院免赔额
      switch (zymbe) {
        case "0":
          zymbeValue = 1;
          break;
        case "10000":
          zymbeValue = 0.8134;
          break;
        default:
          break;
      }
      // 等待期
      switch (waitDay) {
        case "0":
          waitDayVlaue = 0.9264;
          break;
        case "1":
          waitDayVlaue = 1;
          break;
        default:
          break;
      }
      // [住院基准毛保费*(2.1住院免赔额)*(2.2等待期)*(2.3膳食费+床位费)
      // +(门诊保费基准毛保费+理疗和中医治疗费+精神和心理疾病)*(3.1门诊治疗费年度限额)*(3.2门诊免赔额)*(3.3医生费)+生育基准保费*(8.生育医疗年度限额)]
      // *（1.1年度最高保额）*（1.2地理/医院涵盖范围）*紧急医疗保险金
      // +特殊医疗基准保费*（4.既往症限额）
      // +预防性检查基准保费*（5.预防性检查费年度限额）
      // +眼科基准保费*（6.眼科医疗年度限额）
      // +牙科基准保费*（7.牙科医疗年度限额）
      let pre1 = value * zymbeValue * waitDayVlaue * zhuyuanValue;
      let pre2 =
        (mzvalue + Number(liliaoUpgrade) + Number(mzJingshen)) *
          Number(menzhenLimit) *
          mzmpe *
          yishiUpgradeValue +
        syjzPremium * yunchanValue;
      let pre3 =
        (pre1 + pre2) *
        Number(amountValue) *
        Number(dlyyVlaue) *
        Number(jjylndxe);
      let pre4 = pre3 + tsylPremium * tsjwz;
      let pre5 = pre4 + yfxjcPremium * tijian;
      let pre6 = pre5 + yankPremium * yanke;
      let pre7 = pre6 + yakPremium * chike;
      let pre8 = pre7 * ztValue;
      console.log(`[(${value} * ${zymbeValue} * ${waitDayVlaue} * ${zhuyuanValue})+((${mzvalue} + ${liliaoUpgrade} + ${mzJingshen}) * ${menzhenLimit} * ${mzmpe} * ${yishiUpgradeValue} + ${syjzPremium} * ${yunchanValue})]* ${amountValue} * ${dlyyVlaue} * ${jjylndxe} + ${tsylPremium} * ${tsjwz} + ${yfxjcPremium} * ${tijian} + ${yankPremium} * ${yanke} + ${yakPremium} * ${chike} * ${ztValue}`);
      console.log(pre8)
      value = Math.round(pre8);
      return value;
    },
    taAddQuotationData() {
      // 重新计算一下保费
      let validAgeAndNum = true;
      let yunChan = []; // 孕产保障（限5个主被以上团体）
      let errorMsg = "";
      const arr = [];
      let age18Num = 0;
      this.planList.forEach((plan, index) => {
        this.handleCalcPlanPremium(plan);
        const insuredList = plan.insuredList;
        const quotationInsuredListOpt = plan.quotationInsuredListOpt;
        let basicPlanPremium = this.thousandBitSeparator(plan.basicPlanPremium);
        const {
          amount = 50, // 基础保障保额
          menzhenLimit = 0, // 可选保障计划索引
          yishiUpgrade = 0, // 医师诊疗跟专家门诊
          liliaoUpgrade = 0,
          extHospital = 0, // 医院列表索引
          zhongyiUpgrade = 0, // 中医额度增加800/次
          zhuyuan = 0, // 食宿费
          chike = 0,
          tijian = 0,
          mzmpe = 1, // 门诊免赔额
          zymbe = 0, // 住院免赔额
          tsjwz = 0, // 既往症
          jjylndxe = 1,
          yunchan = 0,
          emergencyMedical = 0,
          outAreaMedical = 0,
          mzBZ = 0,
          premium = 0,
          areaCoverage = 0,
          waitDay = 0,
          mzJingshen = 0,
          hosJS = 0,
          hosLZ = 0,
          mzLZ = 0,
          hosZL = 0,
          wlpZYJT = 0,
          fydJTBT = 0,
          shaichaFL = 0,
          teshuZL = 0,
          yanke = 0,
          chuantongZY = 0,
          jjYK = 0,
          shaicha45 = 0,
          shaichaYE1 = 0,
          shaichaYE0_7 = 0,
          shaichaJZBS = 0,
          xiantianJB = 0,
          feijiwangAZB = 0,
          shuimianJC = 0,
          jiatingHL = 0
        } = plan;
        if (yunchan > 0) {
          yunChan.push({
            planName: "计划" + (index + 1),
            index,
            insuredList: plan.insuredList
          });
        }
        let quotationInsuredList = [];
        let total = 0;
        insuredList.map(item => {
          quotationInsuredList.push({
            ageRange: item.age,
            ageRangeCount: item.num ? item.num : 0,
            agePremium: item.basicCale
          });
          if (item.num) {
            total += parseInt(item.num);
            if (parseInt(item.age) > 1) {
              age18Num += parseInt(item.num);
            }
          }
        });
        let yishiUpgrade_ = yishiUpgrade;
        let liliaoUpgrade_ = liliaoUpgrade;
        let zhongyiUpgrade_ = zhongyiUpgrade;
        let menzhenLimit_ = menzhenLimit;
        let mzJingshen_ = mzJingshen;
        let mzLZ_ = mzLZ;
        let chuantongZY_ = chuantongZY;
        let jiatingHL_ = jiatingHL;
        let jjYK_ = jjYK;
        let shuimianJC_ = shuimianJC;
        let shaicha45_ = shaicha45;
        let shaichaYE1_ = shaichaYE1;
        let shaichaYE0_7_ = shaichaYE0_7;
        let shaichaJZBS_ = shaichaJZBS;
        let xiantianJB_ = xiantianJB;
        let feijiwangAZB_ = feijiwangAZB;
        if (menzhenLimit == "0") {
          menzhenLimit_ = "0";
          yishiUpgrade_ = "0";
          zhongyiUpgrade_ = "0";
          liliaoUpgrade_ = "0";
          mzJingshen_ = "0";
          mzLZ_ = "0";
          chuantongZY_ = "0";
          jiatingHL_ = "0";
          jjYK_ = "0";
          shuimianJC_ = "0";
        }
        if (teshuZL == "0") {
          xiantianJB_ = "0";
          feijiwangAZB_ = "0";
        }
        if (shaichaFL == "0") {
          shaicha45_ = "0";
          shaichaYE1_ = "0";
          shaichaYE0_7_ = "0";
          shaichaJZBS_ = "0";
        }

        arr.push({
          index,
          insQuantity: total,
          totalPremium: premium,
          areaCoverage: areaCoverage,
          amount: amount,
          outAreaMedical: outAreaMedical,
          extHospital: extHospital,
          zhuyuan: zhuyuan,
          hosJS: hosJS,
          hosLZ: hosLZ,
          mzmpe: mzmpe,
          zymbe: zymbe,
          tsjwz: tsjwz,
          jjylndxe: jjylndxe,
          hosZL: hosZL,
          wlpZYJT: wlpZYJT,
          fydJTBT: fydJTBT,
          waitDay: waitDay,
          menzhen: mzBZ,
          menzhenLimit: menzhenLimit_,
          yishiUpgrade: yishiUpgrade_,
          liliaoUpgrade: liliaoUpgrade_,
          zhongyiUpgrade: zhongyiUpgrade_,
          chuantongZY: chuantongZY_,
          mzJingshen: mzJingshen_,
          mzLZ: mzLZ_,
          jiatingHL: jiatingHL_,
          jjYK: jjYK_,
          shuimianJC: shuimianJC_,
          shaicha45: shaicha45_,
          shaichaJZBS: shaichaJZBS_,
          shaichaYE1: shaichaYE1_,
          shaichaYE0_7: shaichaYE0_7_,
          xiantianJB: xiantianJB_,
          feijiwangAZB: feijiwangAZB_,
          emergencyMedical: emergencyMedical,
          tijian: tijian,
          yunchan: yunchan,
          chike: chike,
          yanke: yanke,
          quotationInsuredList,
          quotationInsuredListOpt: quotationInsuredListOpt,
          basicPlanPremium: basicPlanPremium
        });
      });
      const {
        name,
        insuranceTime,
        companyId,
        saleName,
        YjRate,
        channelName
      } = this.formInfo;
      const effectDate = moment(this.formInfo.effectDate).format("YYYY-MM-DD");
      const companyName = this.companyList.filter(c => c.value == companyId)[0]
        .text;

      if (this.ifnvs == "1" && !saleName) {
        this.$message.info("输入销售人员名称");
        return Promise.reject();
      }
      if (this.ifnvs == "1" && !channelName) {
        this.$message.info("输入渠道名称，如果没有可以填无");
        return Promise.reject();
      }
      if (!this.agreed) {
        this.$message.info("请勾选“我已阅读并知晓投保须知”");
        return Promise.reject();
      }
      const { totalPeople } = this.formInfo;
      if (totalPeople < 5 || age18Num < 5) {
        this.$message.info(
          "投保团体的被保险人员工总人数不足5人，本次报价为无效报价。"
        );
        return;
      }
      let isOverAge = this.planList.some(e => e.aveAgeNum > 50) ? 1 : 0;
      if (isOverAge) {
        this.$message.info(
          "投保团体的被保险人员工预估平均年龄超过50周岁，本次报价不作为有效报价，报价书仅供参考。"
        );
      }
      // debugger
      // 5名员工及以下团体最多可投保一个计划保障方案；
      // 2、6-10名员工的团体最多可投保两个计划保障方案；
      // 3、超过10名员工的团体最多可投保三个计划保障方案；
      if (age18Num < 6 && this.planList.length > 1) {
        this.$message.info("5名员工及以下团体最多可投保一个计划保障方案");
        return;
      }
      if (yunChan.length > 0) {
        let flag = true;
        yunChan.map(item => {
          let num_total = 0;
          item.insuredList.map(item1 => {
            if (item1.age > 1 && item1.num) {
              num_total += parseInt(item1.num);
            }
          });
          if (num_total < 6) {
            this.$message.info(
              item.planName +
                "的孕产保障需要6个18岁及18岁以上主被团体才可以投保，请移除该保障后再确认"
            );
            flag = false;
          }
        });
        if (flag === false) {
          return;
        }
      }
      if (age18Num < 11 && this.planList.length > 2) {
        this.$message.info("6-10名员工及以下团体最多可投保两个计划保障方案");
        return;
      }
      if (age18Num > 10 && this.planList.length > 3) {
        this.$message.info("超过10名员工及以下团体最多可投保三个计划保障方案");
        return;
      }
      let claimService1 = "1. 在网络医院内提供免现金直接付费服务。";
      let claimService1_EN =
        "1.Direct Billing Services are Provided within MediLink-Global's Provider Network";
      let agePremiumNum1 = 0;
      let ageRangeCountNum1 = 0;
      let agePremiumNum2 = 0;
      let ageRangeCountNum2 = 0;
      let agePremiumNum3 = 0;
      let ageRangeCountNum3 = 0;
      let allPremium = 0;
      var allPeopleNum = 0;
      let underWritingType = "需全面医学核保 Full Medical Underwriting";
      let underWritingContent1 =
        "经保险公司核保通过的既往症保障需按核保决定承保。最终保障生效与否将取决于核保决定。Coverage for approved pre-existing conditions is subject to underwriting decision. Coverage is not guaranteed and subject to underwriting approval.";
      let underWritingContent2 =
        "在投保单健康问卷中申请人未列明的既往症，保险公司将不承担任何保险责任。Non-disclosed conditions will not be covered.";
      let underWritingContent3 = "";
      let underWritingContent4 = "";
      if (
        arr.filter(item => item.extHospital == "0").length > 0 ||
        arr.filter(item => item.extHospital == "1" && item.amount == "50")
          .length > 0 ||
        arr.filter(
          item =>
            item.extHospital != "0" &&
            item.amount == "100" &&
            item.menzhenLimit == "1"
        ).length > 0
      ) {
        claimService1 =
          " 1.本保险在保险责任范围内不提供直付服务，所有理赔需提交中间带做事后理赔。";
        claimService1_EN =
          "1.Direct Billing Services are not Provided, All claims will be processed based on Pay and Claim Procedure.";
      }
      let temp_a = [];
      arr.map((item, index) => {
        if (index == 0) {
          agePremiumNum1 = item.totalPremium;
          ageRangeCountNum1 = item.insQuantity;
        } else if (index == 1) {
          agePremiumNum2 = item.totalPremium;
          ageRangeCountNum2 = item.insQuantity;
        } else {
          agePremiumNum3 = item.totalPremium;
          ageRangeCountNum3 = item.insQuantity;
        }
        allPremium += item.totalPremium;
        allPeopleNum += parseInt(item.insQuantity);
        item.totalPremiumStr = this.thousandBitSeparator(item.totalPremium);
        item.quotationInsuredListOpt.map(item1 => {
          temp_a.push(item1);
        });
      });
      let hasQuotationOpt_yunchan =
        temp_a.filter(item => item.total > 0 && item.name == "可选孕产保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_chike =
        temp_a.filter(item => item.total > 0 && item.name == "可选齿科保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_yanke =
        temp_a.filter(item => item.total > 0 && item.name == "可选眼科保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_tijian =
        temp_a.filter(item => item.total > 0 && item.name == "可选体检保障")
          .length > 0
          ? 1
          : 0;
      // let hasQuotationOpt=temp_a.filter(item=>item.total>0).length>0?1:0
      if (
        (this.addjwz == true &&
          this.people18Num >= 5 &&
          this.people18Num <= 19) ||
        this.people18Num >= 19
      ) {
        underWritingType =
          "承担一般既往症，除外重大既往症 Limited Medical History Disregarded (L-MHD)";
        underWritingContent1 =
          "除上文定义的重大疾病外，承保该团体的一般既往症，无需等待期。Pre-existing conditions are covered without a waiting period, the listed critical illnesses are excluded.";
        underWritingContent2 =
          "符合入保条件的员工和附属被保险人必须在入职后30天内提交入保申请。Eligible employees and dependents requesting coverage during the policy year must enroll within 30 days of the date of eligibility.";
        underWritingContent3 =
          "符合入保条件的新生婴儿需自出生之日30天内提交入保申请。Eligible newborn babies must be enrolled within 30 days of the date of birth.";
        underWritingContent4 =
          "超过入职日期30天或出生日期30天后提交入保申请的，需要提交健康问卷核保，最终保障生效与否将取决于核保决定。Request for enrollment after 30 days or 30 days of eligibility will require a Health Statement for coverage consideration. Coverage is not guaranteed and subject to underwriting approval.";
      } else {
        underWritingContent3 = "";
        underWritingContent4 = "";
      }
      arr.map(item => {
        item.quotationInsuredListOpt.map(item1 => {
          item1.adultPremium = this.thousandBitSeparator(item1.adultPremium);
          item1.childPremium = this.thousandBitSeparator(item1.childPremium);
        });
      });
      let startDate = moment().format("YYYY-MM-DD");
      let expireDate = moment()
        .add("60", "days")
        .format("YYYY-MM-DD");
      let postData = {
        name,
        isOverAge, //是否超过50岁
        insuranceTime: "1年",
        effectDate: startDate,
        startDate: effectDate,
        expireDate: expireDate,
        companyName,
        addPercent: this.addPercent,
        quotationRiskList: arr,
        agePremiumNum1: this.thousandBitSeparator(agePremiumNum1),
        ageRangeCountNum1: ageRangeCountNum1,
        agePremiumNum2: this.thousandBitSeparator(agePremiumNum2),
        ageRangeCountNum2: ageRangeCountNum2,
        agePremiumNum3: this.thousandBitSeparator(agePremiumNum3),
        ageRangeCountNum3: ageRangeCountNum3,
        allPremium: this.thousandBitSeparator(allPremium),
        claimService1: claimService1,
        claimService1_EN: claimService1_EN,
        underWritingType: underWritingType,
        underWritingContent1: underWritingContent1,
        underWritingContent2: underWritingContent2,
        underWritingContent3: underWritingContent3,
        underWritingContent4: underWritingContent4,
        addjwz: this.addjwz,
        hasQuotationOpt_yunchan: hasQuotationOpt_yunchan,
        hasQuotationOpt_chike: hasQuotationOpt_chike,
        hasQuotationOpt_yanke: hasQuotationOpt_yanke,
        hasQuotationOpt_tijian: hasQuotationOpt_tijian
      };
      console.log(postData, "postData===>");
      postData.userId = this.userId;
      setTimeout(() => {
        if (this.ifnvs == "1") {
          postData.saleName = saleName;
          postData.YjRate = YjRate;
          postData.channelName = channelName;
          this.isLoagding = true;
          api
            .quoteTrack(postData)
            .then(res => res.data)
            .then(data => {
              console.log(data, "data==>");
              if (data.returnCode == "0000") {
                api
                  .creatMediLinkQuo(postData)
                  .then(res => res.data)
                  .then(data => {
                    this.isLoagding = false;
                    if (data.returnCode === "0") {
                      window.location.href = data.returnUrl;
                    } else {
                      this.$message.error(data.returnMsg);
                    }
                  });
              } else {
                this.isLoagding = false;
                this.$message.error(data.returnMsg);
              }
            });
        } else {
          this.isLoagding = true;
          api
            .taAddQuotationData(postData)
            .then(res => res.data)
            .then(data => {
              this.isLoagding = false;
              if (data.returnCode === "0") {
                window.location.href = data.returnUrl;
              } else {
                this.$message.error(data.returnMsg);
              }
            });
        }
        this.NumAgeObj = {};
      }, 500);
    },
    taGetQuotationData(id) {
      api
        .taGetQuotationData(id)
        .then(res => res.data)
        .then(data => {
          this.transformData(data.data);
        });
    },
    initStatus() {
      // 路由变化跟刷新都会进入
      const edit = this.$route.name == "medilink-preview" ? false : true;
      if (!edit) {
        this.taGetQuotationData(this.$route.query.id);
      }
      this.initShare(edit);
      return edit;
    },
    handleToPreview() {
      if (!this.formInfo.name) {
        try {
          window.scrollTo(0, 0);
        } catch (error) {}
        this.$message.info("请填写客户名称");
        return;
      }
      if (this.formInfo.name && this.ifnvs != "1" && !this.isValidName) {
        this.$message.info("请输入准确客户名称");
        return;
      }
      if (!this.formInfo.effectDate) {
        try {
          window.scrollTo(0, 0);
        } catch (error) {}
        this.$message.info("请选择生效日期");
        return;
      }
      this.taAddQuotationData();
    },
    handleCalcPlanPremium(plan) {
      let allTotalPremium = 0;
      if (this.stc) {
        clearTimeout(this.stc);
        this.stc = null;
      }
      this.stc = setTimeout(() => {
        let all_num = 0;
        let num_18 = 0;
        this.planList.map(item => {
          item.insuredList.map(item1 => {
            if (item1.num) {
              all_num += Math.round(item1.num);
              if (parseInt(item1.age) > 1) {
                num_18 += Math.round(item1.num);
              }
            }
          });
        });
        this.people18Num = num_18;
        if (num_18 >= 5 && num_18 <= 19) {
          this.checkflag = true;
        } else if (num_18 > 19) {
          this.checkflag = false;
          this.addjwz = true;
        } else {
          this.checkflag = false;
          this.addjwz = false;
        }
        this.planList.map(item1 => {
          let totalPremium = 0;
          let plan = item1;
          let num = 0;
          let num_18 = 0;
          let basicPlanPremium = 0;
          plan.insuredList.forEach((item, index1) => {
            let iNum = 0;
            if (item.num) {
              iNum = Math.round(item.num);
              num += iNum;
            }
            if (item.age > 1 && item.num) {
              num_18 += Math.round(item.num);
            }
            const amount_ = this.calcPremium(
              {
                age: item.age
              },
              plan,
              all_num
            );
            plan.insuredList[index1].basicCale = this.thousandBitSeparator(
              amount_
            );
            totalPremium += amount_ * iNum;
            basicPlanPremium += amount_ * iNum;
          });
          plan.basicPlanPremium = basicPlanPremium;
          allTotalPremium += basicPlanPremium;
          plan.insuredTotalNum = num;
          let quotationInsuredListOpt = JSON.parse(
            JSON.stringify(plan.quotationInsuredListOpt)
          );
          plan.premium = totalPremium;
          plan.premiumS = this.thousandBitSeparator(plan.premium);
          plan.insuredList = [...plan.insuredList];
          plan.quotationInsuredListOpt = [...quotationInsuredListOpt];
        });
        this.allTotalPremium = allTotalPremium;
        this.aallTotalPremium = allTotalPremium;
        this.sumAllPlanData();
      }, 500);
    },
    calcAddBenefit(
      planInsuredNum,
      planInsuredNum18,
      plan,
      index,
      all_num,
      extHospital
    ) {
      let { yunchan, tijian, chike, yanke } = plan;
      let num_18 = planInsuredNum - planInsuredNum18;
      let new_ = {
        coverage: "0",
        adultPremium: "0",
        adultCount: planInsuredNum18,
        childCount: num_18,
        childPremium: "0",
        total: "0"
      };
      let rateJWZ = 100;
      let rateNum = 100;
      let rateYJ = 100;
      if (
        this.addjwz == true &&
        this.people18Num >= 5 &&
        this.people18Num <= 19
      ) {
        rateJWZ = 140;
      }
      if (all_num && all_num >= 20) {
        rateNum = 94;
      }
      // 是否内部版本
      if (this.ifShowYj == true) {
        if (this.formInfo.YjRate == "10") {
          rateYJ = 100 - 7.14;
        } else if (this.formInfo.YjRate == "12") {
          rateYJ = 100 - 4.41;
        } else if (this.formInfo.YjRate == "18") {
          rateYJ = 104.84;
        } else if (this.formInfo.YjRate == "20") {
          rateYJ = 108.33;
        }
      }
      return new_;
    },
    sumAllPlanData() {
      let total = 0;
      let totalPremium = 0;
      this.planList.forEach(item => {
        totalPremium += parseFloat(item.premium);
        total += parseFloat(item.insuredTotalNum);
      });
      this.formInfo = {
        ...this.formInfo,
        totalPremium,
        totalPeople: total
      };
    },
    handleAddPlan() {
      this.planList.push({
        aveAgeNum: 0, //平均年龄
        amount: "500000", // 基础保障保额
        menzhenLimit: "0", // 可选保障计划索引
        mzmpe: "1", // 门诊免赔额
        yishiUpgrade: "0", // 医师诊疗跟专家门诊
        liliaoUpgrade: "0",
        extHospital: "0", // 医院列表索引
        zymbe: "0", // 住院免赔额
        zhongyiUpgrade: "0", // 中医额度增加800/次
        zhuyuan: "0", // 食宿费
        tsjwz: "0", // 既往症
        chike: "0",
        tijian: "0",
        yunchan: "0",
        emergencyMedical: "0",
        jjylndxe: "1",
        mzBZ: "0",
        premium: 0,
        outAreaMedical: "0",
        insuredTotalNum: 0,
        basicPlanPremium: 0,
        insuredList: [
          { age: 0, basicCale: "2,406 " },
          { age: 1, basicCale: "1,979 " },
          { age: 2, basicCale: "2,041" },
          { age: 3, basicCale: "2,121" },
          { age: 4, basicCale: "2,174" },
          { age: 5, basicCale: "2,557" },
          { age: 6, basicCale: "3,091" },
          { age: 7, basicCale: "3,584" },
          { age: 8, basicCale: "4,469" },
          { age: 9, basicCale: "5,163" },
          { age: 10, basicCale: "5,827" },
          { age: 11, basicCale: " 7,681" }
        ],
        areaCoverage: "0",
        zhfs: "1",
        cbtj: "1",
        waitDay: "0",
        mzJingshen: "0",
        hosJS: "0",
        hosLZ: "0",
        mzLZ: "0",
        hosZL: "0",
        wlpZYJT: "0",
        fydJTBT: "0",
        shaichaFL: "0",
        teshuZL: "0",
        yanke: "0",
        chuantongZY: "0",
        jjYK: "0",
        shaicha45: "0",
        shaichaYE1: "0",
        shaichaYE0_7: "0",
        shaichaJZBS: "0",
        xiantianJB: "0",
        feijiwangAZB: "0",
        shuimianJC: "0",
        jiatingHL: "0",
        quotationInsuredListOpt: [
          {
            name: "可选孕产保障",
            coverage: "0",
            adultCount: 0,
            adultPremium: "0",
            childCount: 0,
            childPremium: "0",
            total: "0"
          },
          {
            name: "可选齿科保障",
            coverage: "0",
            adultCount: 0,
            adultPremium: "0",
            childCount: 0,
            childPremium: "0",
            total: "0"
          },
          {
            name: "可选体检保障",
            coverage: "0",
            adultCount: 0,
            adultPremium: "0",
            childCount: 0,
            childPremium: "0",
            total: "0"
          },
          {
            name: "可选眼科保障",
            coverage: "0",
            adultCount: 0,
            adultPremium: "0",
            childCount: 0,
            childPremium: "0",
            total: "0"
          }
        ]
      });
    },
    handleAddInsuredPerson(item, index) {
      if (index == 0) {
        item.insuredList.push({});
      } else {
        item.insuredList.splice(index, 1);
      }
      this.handleCalcPlanPremium(item);
    },
    handlePlanChange(val, item) {
      this.handleCalcPlanPremium(item);
    },
    onChangeDate(date, dateString) {
      console.log(this.formInfo.effectDate, "===>");
    },
    disabledDate(currentDate) {
      return currentDate && currentDate < moment();
    },
    thousandBitSeparator(num) {
      var num = (num || 0).toString(),
        result = "";
      while (num.length > 3) {
        result = "," + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
      }
      if (num) {
        result = num + result;
      }
      return result;
    },
    checkAdd() {
      if (this.checkflag == true) {
        this.addjwz = !this.addjwz;
        this.planList.forEach((plan, index) => {
          this.handleCalcPlanPremium(plan);
        });
      }
    },
    changeYj() {
      if (this.ifShowYj == true) {
        this.planList.forEach((plan, index) => {
          this.handleCalcPlanPremium(plan);
        });
      }
    },
    searchName() {
      if (!this.searchKey) {
        this.$message.error("请输入客户名称！");
      } else {
        let requestData = {
          name: this.searchKey,
          userId: this.userId
        };
        api
          .queryMediLinkQuo(requestData)
          .then(res => res.data)
          .then(data => {
            console.log(data, "==>");
            this.fetchData = data[0];
            if (this.fetchData.effectiveDate) {
              this.fetchData.effectiveDate = moment(
                this.fetchData.effectiveDate
              ).format("YYYY-MM-DD");
            }
            console.log(this.fetchData, "this.fetchData===>");
            this.showReturn = true;
          });
      }
    },
    changeCheck(e) {
      this.agreed = e.target.checked;
      this.formatData();
    },
    formatData() {
      // 重新计算一下保费
      let validAgeAndNum = true;
      let yunChan = []; // 孕产保障（限5个主被以上团体）
      let errorMsg = "";
      const arr = [];
      let age18Num = 0;
      this.planList.forEach((plan, index) => {
        this.handleCalcPlanPremium(plan);
        const insuredList = plan.insuredList;
        const quotationInsuredListOpt = plan.quotationInsuredListOpt;
        let basicPlanPremium = this.thousandBitSeparator(plan.basicPlanPremium);
        const {
          amount = 500000, // 基础保障保额
          menzhenLimit = 0, // 可选保障计划索引
          yishiUpgrade = 0, // 医师诊疗跟专家门诊
          liliaoUpgrade = 0,
          extHospital = 0, // 医院列表索引
          zhongyiUpgrade = 0, // 中医额度增加800/次
          zhuyuan = 0, // 食宿费
          chike = 0,
          tijian = 0,
          yunchan = 0,
          emergencyMedical = 0,
          outAreaMedical = 0,
          mzBZ = 0,
          premium = 0,
          areaCoverage = 0,
          waitDay = 0,
          mzJingshen = 0,
          hosJS = 0,
          hosLZ = 0,
          mzLZ = 0,
          hosZL = 0,
          wlpZYJT = 0,
          fydJTBT = 0,
          shaichaFL = 0,
          teshuZL = 0,
          yanke = 0,
          chuantongZY = 0,
          jjYK = 0,
          shaicha45 = 0,
          shaichaYE1 = 0,
          shaichaYE0_7 = 0,
          shaichaJZBS = 0,
          xiantianJB = 0,
          feijiwangAZB = 0,
          shuimianJC = 0,
          jiatingHL = 0
        } = plan;
        if (yunchan > 0) {
          yunChan.push({
            planName: "计划" + (index + 1),
            index,
            insuredList: plan.insuredList
          });
        }
        let quotationInsuredList = [];
        let total = 0;
        insuredList.map(item => {
          quotationInsuredList.push({
            ageRange: item.age,
            ageRangeCount: item.num ? item.num : 0,
            agePremium: item.basicCale
          });
          if (item.num) {
            total += parseInt(item.num);
            if (parseInt(item.age) > 1) {
              age18Num += parseInt(item.num);
            }
          }
        });
        let yishiUpgrade_ = yishiUpgrade;
        let liliaoUpgrade_ = liliaoUpgrade;
        let zhongyiUpgrade_ = zhongyiUpgrade;
        let menzhenLimit_ = menzhenLimit;
        let mzJingshen_ = mzJingshen;
        let mzLZ_ = mzLZ;
        let chuantongZY_ = chuantongZY;
        let jiatingHL_ = jiatingHL;
        let jjYK_ = jjYK;
        let shuimianJC_ = shuimianJC;
        let shaicha45_ = shaicha45;
        let shaichaYE1_ = shaichaYE1;
        let shaichaYE0_7_ = shaichaYE0_7;
        let shaichaJZBS_ = shaichaJZBS;
        let xiantianJB_ = xiantianJB;
        let feijiwangAZB_ = feijiwangAZB;
        if (menzhenLimit == "0") {
          menzhenLimit_ = "0";
          yishiUpgrade_ = "0";
          zhongyiUpgrade_ = "0";
          liliaoUpgrade_ = "0";
          mzJingshen_ = "0";
          mzLZ_ = "0";
          chuantongZY_ = "0";
          jiatingHL_ = "0";
          jjYK_ = "0";
          shuimianJC_ = "0";
        }
        if (teshuZL == "0") {
          xiantianJB_ = "0";
          feijiwangAZB_ = "0";
        }
        if (shaichaFL == "0") {
          shaicha45_ = "0";
          shaichaYE1_ = "0";
          shaichaYE0_7_ = "0";
          shaichaJZBS_ = "0";
        }

        arr.push({
          index,
          insQuantity: total,
          totalPremium: premium,
          areaCoverage: areaCoverage,
          amount: amount,
          outAreaMedical: outAreaMedical,
          extHospital: extHospital,
          zhuyuan: zhuyuan,
          hosJS: hosJS,
          hosLZ: hosLZ,
          hosZL: hosZL,
          wlpZYJT: wlpZYJT,
          fydJTBT: fydJTBT,
          waitDay: waitDay,
          menzhen: mzBZ,
          menzhenLimit: menzhenLimit_,
          yishiUpgrade: yishiUpgrade_,
          liliaoUpgrade: liliaoUpgrade_,
          zhongyiUpgrade: zhongyiUpgrade_,
          chuantongZY: chuantongZY_,
          mzJingshen: mzJingshen_,
          mzLZ: mzLZ_,
          jiatingHL: jiatingHL_,
          jjYK: jjYK_,
          shuimianJC: shuimianJC_,
          shaicha45: shaicha45_,
          shaichaJZBS: shaichaJZBS_,
          shaichaYE1: shaichaYE1_,
          shaichaYE0_7: shaichaYE0_7_,
          xiantianJB: xiantianJB_,
          feijiwangAZB: feijiwangAZB_,
          emergencyMedical: emergencyMedical,
          tijian: tijian,
          yunchan: yunchan,
          chike: chike,
          yanke: yanke,
          quotationInsuredList,
          quotationInsuredListOpt: quotationInsuredListOpt,
          basicPlanPremium: basicPlanPremium
        });
      });
      const {
        name,
        insuranceTime,
        companyId,
        saleName,
        YjRate,
        channelName
      } = this.formInfo;
      const effectDate = moment(this.formInfo.effectDate).format("YYYY-MM-DD");
      const companyName = this.companyList.filter(c => c.value == companyId)[0]
        .text;

      if (this.ifnvs == "1" && !saleName) {
        this.$message.info("输入销售人员名称");
        return Promise.reject();
      }
      if (this.ifnvs == "1" && !channelName) {
        this.$message.info("输入渠道名称，如果没有可以填无");
        return Promise.reject();
      }
      if (!this.agreed) {
        this.$message.info("请勾选“我已阅读并知晓投保须知”");
        return Promise.reject();
      }
      const { totalPeople } = this.formInfo;
      if (totalPeople < 5 || age18Num < 5) {
        this.$message.info(
          "投保团体的被保险人员工总人数不足5人，本次报价为无效报价。"
        );
        return;
      }
      // if (this.planList.some(e=>e.aveAgeNum>50)) {
      //     this.$message.info('投保团体的被保险人员工预估平均年龄超过50周岁，本次报价不作为有效报价，报价书仅供参考。');
      // }
      // 5名员工及以下团体最多可投保一个计划保障方案；
      // 2、6-10名员工的团体最多可投保两个计划保障方案；
      // 3、超过10名员工的团体最多可投保三个计划保障方案；
      if (age18Num < 6 && this.planList.length > 1) {
        this.$message.info("5名员工及以下团体最多可投保一个计划保障方案");
        return;
      }
      if (yunChan.length > 0) {
        let flag = true;
        yunChan.map(item => {
          let num_total = 0;
          item.insuredList.map(item1 => {
            if (item1.age > 1 && item1.num) {
              num_total += parseInt(item1.num);
            }
          });
          if (num_total < 6) {
            this.$message.info(
              item.planName +
                "的孕产保障需要6个18岁及18岁以上主被团体才可以投保，请移除该保障后再确认"
            );
            flag = false;
          }
        });
        if (flag === false) {
          return;
        }
      }
      if (age18Num < 11 && this.planList.length > 2) {
        this.$message.info("6-10名员工及以下团体最多可投保两个计划保障方案");
        return;
      }
      if (age18Num > 10 && this.planList.length > 3) {
        this.$message.info("超过10名员工及以下团体最多可投保三个计划保障方案");
        return;
      }
      let claimService1 = "1. 在网络医院内提供免现金直接付费服务。";
      let claimService1_EN =
        "1.Direct Billing Services are Provided within MediLink-Global's Provider Network";
      let agePremiumNum1 = 0;
      let ageRangeCountNum1 = 0;
      let agePremiumNum2 = 0;
      let ageRangeCountNum2 = 0;
      let agePremiumNum3 = 0;
      let ageRangeCountNum3 = 0;
      let allPremium = 0;
      let allPeopleNum = 0;
      let underWritingType = "需全面医学核保 Full Medical Underwriting";
      let underWritingContent1 =
        "经保险公司核保通过的既往症保障需按核保决定承保。最终保障生效与否将取决于核保决定。Coverage for approved pre-existing conditions is subject to underwriting decision. Coverage is not guaranteed and subject to underwriting approval.";
      let underWritingContent2 =
        "在投保单健康问卷中申请人未列明的既往症，保险公司将不承担任何保险责任。Non-disclosed conditions will not be covered.";
      let underWritingContent3 = "";
      let underWritingContent4 = "";
      if (
        arr.filter(item => item.extHospital == "0").length > 0 ||
        arr.filter(item => item.extHospital == "1" && item.amount == "50")
          .length > 0 ||
        arr.filter(
          item =>
            item.extHospital != "0" &&
            item.amount == "100" &&
            item.menzhenLimit == "1"
        ).length > 0
      ) {
        claimService1 =
          " 1.本保险在保险责任范围内不提供直付服务，所有理赔需提交中间带做事后理赔。";
        claimService1_EN =
          "1.Direct Billing Services are not Provided, All claims will be processed based on Pay and Claim Procedure.";
      }
      let temp_a = [];
      arr.map((item, index) => {
        if (index == 0) {
          agePremiumNum1 = item.totalPremium;
          ageRangeCountNum1 = item.insQuantity;
        } else if (index == 1) {
          agePremiumNum2 = item.totalPremium;
          ageRangeCountNum2 = item.insQuantity;
        } else {
          agePremiumNum3 = item.totalPremium;
          ageRangeCountNum3 = item.insQuantity;
        }
        allPremium += item.totalPremium;
        allPeopleNum += parseInt(item.insQuantity);
        item.totalPremiumStr = this.thousandBitSeparator(item.totalPremium);
        item.quotationInsuredListOpt.map(item1 => {
          temp_a.push(item1);
        });
      });
      let hasQuotationOpt_yunchan =
        temp_a.filter(item => item.total > 0 && item.name == "可选孕产保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_chike =
        temp_a.filter(item => item.total > 0 && item.name == "可选齿科保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_yanke =
        temp_a.filter(item => item.total > 0 && item.name == "可选体检保障")
          .length > 0
          ? 1
          : 0;
      let hasQuotationOpt_tijian =
        temp_a.filter(item => item.total > 0 && item.name == "可选眼科保障")
          .length > 0
          ? 1
          : 0;
      // let hasQuotationOpt=temp_a.filter(item=>item.total>0).length>0?1:0
      if (
        (this.addjwz == true &&
          this.people18Num >= 5 &&
          this.people18Num <= 19) ||
        this.people18Num >= 19
      ) {
        underWritingType =
          "承担一般既往症，除外重大既往症 Limited Medical History Disregarded (L-MHD)";
        underWritingContent1 =
          "除上文定义的重大疾病外，承保该团体的一般既往症，无需等待期。Pre-existing conditions are covered without a waiting period, the listed critical illnesses are excluded.";
        underWritingContent2 =
          "符合入保条件的员工和附属被保险人必须在入职后30天内提交入保申请。Eligible employees and dependents requesting coverage during the policy year must enroll within 30 days of the date of eligibility.";
        underWritingContent3 =
          "符合入保条件的新生婴儿需自出生之日30天内提交入保申请。Eligible newborn babies must be enrolled within 30 days of the date of birth.";
        underWritingContent4 =
          "超过入职日期30天或出生日期30天后提交入保申请的，需要提交健康问卷核保，最终保障生效与否将取决于核保决定。Request for enrollment after 30 days or 30 days of eligibility will require a Health Statement for coverage consideration. Coverage is not guaranteed and subject to underwriting approval.";
      } else {
        underWritingContent3 = "";
        underWritingContent4 = "";
      }
      arr.map(item => {
        item.quotationInsuredListOpt.map(item1 => {
          item1.adultPremium = this.thousandBitSeparator(item1.adultPremium);
          item1.childPremium = this.thousandBitSeparator(item1.childPremium);
        });
      });
      let startDate = moment().format("YYYY-MM-DD");
      let expireDate = moment()
        .add("60", "days")
        .format("YYYY-MM-DD");
      let postData = {
        name,
        insuranceTime: "1年",
        effectDate: startDate,
        startDate: effectDate,
        expireDate: expireDate,
        companyName,
        quotationRiskList: arr,
        agePremiumNum1: this.thousandBitSeparator(agePremiumNum1),
        ageRangeCountNum1: ageRangeCountNum1,
        agePremiumNum2: this.thousandBitSeparator(agePremiumNum2),
        ageRangeCountNum2: ageRangeCountNum2,
        agePremiumNum3: this.thousandBitSeparator(agePremiumNum3),
        ageRangeCountNum3: ageRangeCountNum3,
        allPremium: this.thousandBitSeparator(allPremium),
        claimService1: claimService1,
        claimService1_EN: claimService1_EN,
        underWritingType: underWritingType,
        underWritingContent1: underWritingContent1,
        underWritingContent2: underWritingContent2,
        underWritingContent3: underWritingContent3,
        underWritingContent4: underWritingContent4,
        addjwz: this.addjwz,
        hasQuotationOpt_yunchan: hasQuotationOpt_yunchan,
        hasQuotationOpt_chike: hasQuotationOpt_chike,
        hasQuotationOpt_yanke: hasQuotationOpt_yanke,
        hasQuotationOpt_tijian: hasQuotationOpt_tijian
      };
      if (this.ifnvs == "1") {
        postData.userId = this.userId;
        postData.saleName = saleName;
        postData.YjRate = YjRate;
        postData.channelName = channelName;
      }
      console.log(JSON.stringify(postData), "postData===>");
    }
  }
};
</script>